// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2020-02-04T13:29:42+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  60896
//    Project:        153
//    Environment:    306 - master
//    MD5:            2e83e6fa57f97ffae89f6652f804019d
//    Signature:      eyJpdiI6ImJCQjZtRk54UTJsZnFlQ0g3cUZkSWc9PSIsInZhbHVlIjoiRFwvRHNIV2JlU1BBNDY2dnVIbDlsbjBxMEVYRnprc0ZJcW8rOUVNQUs4ZURTSTVqcnNzSzBDQmt2clJoT1FEc3ZwWFwvY1RNb0NlV2hjdzRJQyt1Qk14ZDJqWEo0KzN2b0tBajdQU1EwZDVRXC9YVG1ySUFZZkc0SzFuUnFHNEFPSlJ3dFQ0b2gxMWJ2eFdEeTNLSlUyaDlcL3lsXC9kQjlBdmpIQ3lmRk1cL1hyU3dpRmZVc1pZRXdXYkZaNFRsTTdTK092NTN2YUx1ZTVrejRLYXNUYTBSZVN6UVE4N0dkekgyelwvTDBNTGdDamg4MnVGa3F3Q0RrZGR3K01sVmNmQmtoeWR1ZGlLTVBBTHdaeDBDbDNBM21VYklhT05VNXM5NCtPYVFMZHlpeFBneHFNUGJVNkpodU4raFJiWHlOV1wvRHluc1JcL3k4TnpVVWxhOElVc1Q0aWNmXC9BQlMxTjJHS0NNYjMyaDNwaXphT3Jvd1ZiR2dJSFNVMWdGc3JXdW5IdFpIa3NsUndCa2lBaTFjMHFTU1VOMGNld1E9PSIsIm1hYyI6ImI5Yjc1OTY1NGRmZTI1YWViZjJkNTgyMWJlZjE1MGVmNzQ1M2ExM2E0M2NiYzQyZTg3NTMxN2FiNTBjOTY1ZGUifQ==
// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.

if (navigator.userAgent.indexOf("Firefox") > 0) {
	document.documentElement.classList.add('mozilla');
}

var utilities = {
	toggleBodyScroll: function () {
		$("body").toggleClass("noscroll");
		$("html").toggleClass("noscroll");
	},
};

function setupVariables(){
			let vh = window.innerHeight * 0.01;
			if (document.querySelector('.l-page__header')) {
					let headerHeight = document.querySelector('.l-page__header').offsetHeight - 1;
					document.documentElement.style.setProperty('--vh', `${vh}px`);
					document.documentElement.style.setProperty('--headerHeight', `${headerHeight}px`);
			}
}

window.addEventListener('load', setupVariables);

// var searchBar = {
//     $inputField: $('.o-search-from__field:visible'),
//     $header: $('header'),
//     openButtonSelector: '.k-menu__toggle-search',
//     closeButtonSelector: '.o-search-from__close',
//     $mobileOverlay: $('#mobile-search'),
//     mobileOverlayOpenClass: 'mobile-search--open',
//     $backgroundOverlay: $('.body-overlay'),
//     clearButtonSelector: '#clear-search-input',
//     searchPageLinkSelector: '.aa-autocomplete__link',
//     init: function() {
//         var open = this.open.bind(this);
//         var close = this.close.bind(this);
//         var clear = this.clear.bind(this);
//         var redirect = this.redirectToSearchPage.bind(this);

//         $(document).on("click", this.openButtonSelector, function (e) {
//             open();
//         });

//         $(document).on("click", this.closeButtonSelector, function (e) {
//             close();
//         });
//         this.$backgroundOverlay.on("click", function (e) {
//             close();
//         });

//         $(document).on("click", this.clearButtonSelector, function (e) {
//             clear();
//         });

//         $(document).on("click", this.searchPageLinkSelector, function (e) {
//             redirect();
//         });
//     },
//     open: function () {
//         this.$header.addClass('search-form--visible');
//         this.$mobileOverlay.addClass(this.mobileOverlayOpenClass);
//         this.$inputField.focus();
//         $(this.openButtonSelector).fadeOut(100);
//         $(this.closeButtonSelector).fadeIn(200);
//         this.$backgroundOverlay.fadeIn(200);
//         utilities.toggleBodyScroll();
//     },
//     close: function() {
//         this.$header.removeClass('search-form--visible');
//         this.$mobileOverlay.removeClass(this.mobileOverlayOpenClass);
//         $(this.closeButtonSelector).fadeOut(100);
//         $(this.openButtonSelector).fadeIn(200);
//         this.$backgroundOverlay.fadeOut(100);
//         utilities.toggleBodyScroll();
//     },
//     clear: function() {
//         this.$inputField.val('');
//     },
//     redirectToSearchPage: function() {
//         var link = "/search?type=product&q=";
//         var query = this.$inputField.val();
//         window.location.href = link + query;
//     }
// }

// var mobileSearch = {
// 	$inputField: $(".o-search-from__field:visible"),
// 	$header: $("header"),
// 	openButtonSelector: "#mobileMenuToggle",
// 	closeButtonSelector: ".o-search-from__close",
// 	$mobileOverlay: $("#mobile-search"),
// 	$backgroundOverlay: $(".body-overlay"),
// 	mobileOverlayOpenClass: "mobile-search--open",
// 	init: function () {
// 		var open = this.open.bind(this);
// 		var close = this.close.bind(this);

// 		$(document).on("click", this.openButtonSelector, function (e) {
// 			open();
// 		});

// 		$(document).on("click", this.closeButtonSelector, function (e) {
// 			close();
// 		});
// 	},
// 	open: function () {
// 		this.$header.addClass("search-form--visible");
// 		this.$mobileOverlay.addClass(this.mobileOverlayOpenClass);
// 		this.$inputField.focus();
// 		$(this.openButtonSelector).fadeOut(100);
// 		$(this.closeButtonSelector).fadeIn(200);
// 		this.$backgroundOverlay.fadeIn(200);
// 		utilities.toggleBodyScroll();
// 	},
// 	close: function () {
// 		this.$header.removeClass("search-form--visible");
// 		this.$mobileOverlay.removeClass(this.mobileOverlayOpenClass);
// 		$(this.closeButtonSelector).fadeOut(100);
// 		$(this.openButtonSelector).fadeIn(200);
// 		this.$backgroundOverlay.fadeOut(100);
// 		utilities.toggleBodyScroll();
// 	},
// };

var cookieBanner = {
	selector: ".cookie-banner",
	cookieName: "KoibirdCookieAccepted",
	cookieValue: "true",
	daysStored: 30,
	expiryDate: function (date) {
		date.setTime(date.getTime() + this.daysStored * 24 * 60 * 60 * 1000);
		return "expires=" + date.toGMTString();
	},
	isCookiePresent: function () {
		if (
			document.cookie.includes(this.cookieName + "=" + this.cookieValue)
		) {
			return true;
		} else {
			return false;
		}
	},
	storeCookie: function () {
		document.cookie =
			this.cookieName +
			"=" +
			this.cookieValue +
			";" +
			this.expiryDate(new Date()) +
			"; Secure; path=/";
	},
	show: function () {
		$(this.selector).addClass("cookie-banner--visible");
	},
	hide: function () {
		$(this.selector).removeClass("cookie-banner--visible");
	},
	onCookieAccepted: function () {
		// console.log(this);
		this.storeCookie();
		this.hide();
	},
};

function caroustack(params) {
	if ($(".card-carousel").length === 0) {
		return;
	}

	// params
	params = params || {};
	var sectionId = params.parent.data("id");
	var parentSelector = "[data-id=" + '"' + sectionId + '"]';
	this.container = document.querySelector(parentSelector + " .container");

	this.items = document.querySelectorAll(
		parentSelector + " .container" + " > " + (params.items || ".item")
	);
	this.dots = document.querySelectorAll(
		parentSelector + " .card-carousel__dots__item"
	);

	// transition variables
	this.currentSlide = 0;
	this.tempSlide = this.currentSlide;
	this.nextSlide = Math.min(this.currentSlide + 1, this.items.length - 1);
	this.delta = 0;
	this.angle = 0;

	// handlers
	this.initHandler = (event) => this.initScroll(event);
	this.moveHandler = (event) => this.moveScroll(event);
	this.endHandler = (event) => this.endScroll(event);

	// listeners
	this.container.addEventListener("pointerdown", this.initHandler);
	this.container.addEventListener("pointerup", this.endHandler);
	this.container.addEventListener("pointercancel", this.endHandler);

	// set item order
	this.items.forEach((i, index) => (i.style.zIndex = -index));
	this.items[this.currentSlide].classList.add("active");
	this.dots[this.currentSlide].classList.add("active");
	this.items[this.nextSlide].classList.add("next");

	this.initScroll = function (event) {
		// set initial values
		this.initialTouch = event.clientX;
		this.container.classList.add("sliding");
		this.container.addEventListener("pointermove", this.moveHandler);
	};

	this.moveScroll = function (event) {
		// transition values
		this.delta = this.initialTouch - event.clientX;
		this.angle = this.delta / 100;
		this.scaling = 1 - Math.abs(this.delta) / 5000;

		// limit direction on first and last items
		if (
			Math.sign(this.delta) > 0 &&
			this.currentSlide === this.items.length - 1
		)
			return;
		else if (Math.sign(this.delta) < 0 && this.currentSlide === 0) return;

		// set different slide if right or left
		let slide = this.tempSlide;
		this.tempSlide =
			this.delta < 0
				? Math.max(this.currentSlide - 1, 0)
				: this.currentSlide;

		// prevent spam slide stuck
		if (this.tempSlide !== slide) {
			this.items[slide].style.transform = `none`;
		}

		// update slide position
		this.items[this.tempSlide].style.transform = `translateX(${-this
			.delta}px) rotate(${-this.angle}deg) scale(${this.scaling})`;
		this.items[this.tempSlide].classList.add("moving");
	};

	this.endScroll = function (event) {
		// reset values
		this.container.removeEventListener(
			"pointermove",
			this.moveHandler,
			false
		);
		this.container.classList.remove("sliding");
		this.items[this.tempSlide].style.transform = `none`;
		this.items[this.tempSlide].classList.remove("moving");

		// you need to slide up to 50px to go prev/next
		if (Math.abs(this.delta) < 50) return;

		// reset items classes
		this.items.forEach((i) => {
			i.classList.remove("active");
			i.classList.remove("next");
			i.classList.remove("previous");
		});

		// reset active dot
		this.dots.forEach((i) => {
			i.classList.remove("active");
		});

		// set current slide
		this.currentSlide =
			this.delta > 0
				? Math.min(this.tempSlide + 1, this.items.length - 1)
				: this.tempSlide;
		this.items[this.currentSlide].classList.add("active");
		this.dots[this.currentSlide].classList.add("active");

		// set previous slide
		if (this.currentSlide > 0) {
			this.items[this.currentSlide - 1].classList.add("previous");
		}

		// set next slide
		this.nextSlide = Math.min(this.currentSlide + 1, this.items.length - 1);
		this.items[this.nextSlide].classList.add("next");
	};
}

function initCustomSelect() {
	for (const dropdown of document.querySelectorAll(".select-wrapper")) {
		dropdown.addEventListener("click", function () {
			this.querySelector(".select").classList.toggle("open");
		});
	}

	for (const option of document.querySelectorAll(".custom-option")) {
		option.addEventListener("click", function () {
			if (!this.classList.contains("selected")) {
				// console.log("inside");
				// console.log(this);
				this.parentNode.querySelector(".custom-option.selected") &&
					this.parentNode
						.querySelector(".custom-option.selected")
						.classList.remove("selected");
				this.classList.add("selected");
				this.closest(".select").querySelector(
					".select__trigger span"
				).textContent = this.textContent;
			}
		});
	}

	window.addEventListener("click", function (e) {
		for (const select of document.querySelectorAll(".select")) {
			if (!select.contains(e.target)) {
				select.classList.remove("open");
			}
		}
	});
}

$(document).ready(function () {
	initCustomSelect();

	// cookie banner behaviour

	if (!cookieBanner.isCookiePresent()) {
		cookieBanner.show();
	}
	$(document).on("click", "#accept_cookie_policy", function () {
		var onCookieAccepted = cookieBanner.onCookieAccepted.bind(cookieBanner);
		onCookieAccepted();
	});

	// Mobile search
	// mobileSearch.init();

	// Nav hover

	$(".c-menu--main__item").hover(function () {
		$(this).parent().toggleClass("main-menu__item--hovered");
		var subMenus = $(this).find(".c-menu__submenu");
		if (subMenus.length > 0) {
			$(this)
				.closest(".l-header--transparent")
				.toggleClass("drawer--open");
		}
	});

	// Mobile Nav close on clicking outside nav

	$("body").click(function (e) {
		if (
			$(e.target).closest(".o-mobile-menu--open").length === 0 &&
			$(e.target).closest(".o-menu-toggle__link").length === 0
		) {
			$(".o-mobile-menu").removeClass("o-mobile-menu--open");
			$("body").removeClass("o-body--menu-active");
		}
	});

	// disable empty links

	$('a[href=""]').click(function (e) {
		e.preventDefault();
	});

	// Collection Pages Load more button

	$(".ajaxinate-pagination-load-more").click(function () {
		$(this).addClass("c-button--loading");
	});

	// Slick Carousel Initialisation

	$(".three-item-carousel").each(function () {
		$(this).slick({
			infinite: false,
			speed: 300,
			slidesToShow: 3,
			slidesToScroll: 3,
			prevArrow: $(this)
				.closest(".three-item-carousel-container")
				.find(".r-carousel_arrows--left"),
			nextArrow: $(this)
				.closest(".three-item-carousel-container")
				.find(".r-carousel_arrows--right"),
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		});
	});

	$(".r-carousel").each(function () {
		var slidesToShow = $(this).hasClass("r-carousel--four-items") ? 4 : 6;
		$(this).slick({
			infinite: true,
			speed: 300,
			slidesToShow: slidesToShow,
			slidesToScroll: slidesToShow,
			prevArrow: $(this)
				.closest(".r-carousel-container")
				.find(".r-carousel_arrows--left"),
			nextArrow: $(this)
				.closest(".r-carousel-container")
				.find(".r-carousel_arrows--right"),
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					},
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4,
					},
				},
			],
		});
	});

	$(".single-item-carousel--centered").each(function () {
		$(this).slick({
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			prevArrow: $(this)
				.closest(".single-item-carousel-container")
				.find(".r-carousel_arrows--left"),
			nextArrow: $(this)
				.closest(".single-item-carousel-container")
				.find(".r-carousel_arrows--right"),
			centerMode: true,
			variableWidth: true,
			adaptiveHeight: true,
			centerPadding: "15%",
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						centerPadding: "10%",
					},
				},
			],
		});
	});

	$(".shop-the-look-carousel").each(function () {
		$(this).slick({
			infinite: true,
			speed: 300,
			slidesToShow: 3,
			slidesToScroll: 3,
			prevArrow: $(this)
				.closest(".shop-the-look-carousel-container")
				.find(".r-carousel_arrows--left"),
			nextArrow: $(this)
				.closest(".shop-the-look-carousel-container")
				.find(".r-carousel_arrows--right"),
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					},
				},
			],
		});
	});

	// Image Gallery Mobile Slick

	$('.image-gallery [data-pf-type="Column"]').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		prevArrow: $(".image-gallery")
			.closest(".image-gallery-container")
			.find(".r-carousel_arrows--left button"),
		nextArrow: $(".image-gallery")
			.closest(".image-gallery-container")
			.find(".r-carousel_arrows--right button"),
		adaptiveHeight: true,
		mobileFirst: true,
		infinite: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: "unslick",
			},
		],
	});

	// Mobile filters

	$(".c-filter-close--mobile").click(function () {
		$(".c-filter-menu--mobile").slideUp();
	});

	$(".c-filter-toggle--mobile").click(function () {
		utilities.toggleBodyScroll();
	});

	// Card carousel

	$(".card-carousel").each(function () {
		var parent = $(this);
		var initCarousel = caroustack.bind({}, { parent: parent });
		initCarousel();
	});

	// Stacked hero interaction

	$(".hero-stacked__item").on("mousedown", changeStackOrder);

	var autoChangeStackOrder = function () {
		var selected = $(".hero-stacked__item.selected");
		selected.removeClass("selected");
		var currentDot = $(".hero-stacked .carousel-dots__item.current");
		currentDot.toggleClass("current complete");
		$(".hero-stacked__item").removeClass("previous");
		selected.addClass("previous");
		if (selected.is($(".hero-stacked__item:last"))) {
			$(".hero-stacked__item:first").addClass("selected");
			$(".hero-stacked .carousel-dots__item").removeClass("complete");
			setTimeout(function () {
				$(".hero-stacked .carousel-dots__item")
					.first()
					.addClass("current");
			}, 10);
		} else {
			selected.next().addClass("selected");
			currentDot.next().addClass("current");
		}
	};

	$(".hero-stacked .carousel-dots__item").first().addClass("current");

	if (window.innerWidth > 768) {
		var heroTimer = setInterval(autoChangeStackOrder, 6000);
	}

	function changeStackOrder() {
		clearInterval(heroTimer);
		$(".hero-stacked .carousel-dots").hide();
		var selected = $(".hero-stacked .selected");
		var previous = $(".hero-stacked .previous");
		if (!$(this).hasClass("selected")) {
			previous.removeClass("previous");
			selected.toggleClass("selected previous");
			$(this).addClass("selected");
		}
	}

	$(".hero-stacked-mobile").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		slide: ".hero-stacked__item--mobile",
		prevArrow: $(".hero-stacked-mobile__nav").find(
			".hero-stacked-mobile__nav__arrow--left"
		),
		nextArrow: $(".hero-stacked-mobile__nav").find(
			".hero-stacked-mobile__nav__arrow--right"
		),
		dots: true,
		customPaging: function () {
			return "<span></span>";
		},
		appendDots: ".hero-stacked-mobile__dots-container",
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: "linear",
		autoplay: true,
		autoplaySpeed: 3000,
		mobileFirst: true,
		responsive: [
			{
				breakpoint: 768,
				settings: "unslick",
			},
		],
	});

	$(".image-gallery .hero-stacked__item").each(function () {
		dragElement(this);
	});
	// dragElement($('.image-gallery .image2')[0]);
	dragElement(document.getElementById("slide1"));
	dragElement(document.getElementById("slide2"));
	dragElement(document.getElementById("slide3"));

	function dragElement(elmnt) {
		if (elmnt === null) {
			return;
		}
		var containerHeight = $(".hero-stacked").height();
		var elementHeight = $(elmnt).height();
		var containerWidth = $(".hero-stacked").width();
		var elementWidth = $(elmnt).width();
		var pos1 = 0,
			pos2 = 0,
			pos3 = 0,
			pos4 = 0;
		if (document.getElementById(elmnt.id + "header")) {
			/* if present, the header is where you move the DIV from:*/
			document.getElementById(elmnt.id + "header").onmousedown =
				dragMouseDown;
		} else {
			/* otherwise, move the DIV from anywhere inside the DIV:*/
			elmnt.onmousedown = dragMouseDown;
		}

		function dragMouseDown(e) {
			e = e || window.event;
			e.preventDefault();
			// get the mouse cursor position at startup:
			pos3 = e.clientX;
			pos4 = e.clientY;
			document.onmouseup = closeDragElement;
			// call a function whenever the cursor moves:
			document.onmousemove = elementDrag;
		}

		function elementDrag(e) {
			e = e || window.event;
			e.preventDefault();
			// calculate the new cursor position:
			pos1 = pos3 - e.clientX;
			pos2 = pos4 - e.clientY;
			pos3 = e.clientX;
			pos4 = e.clientY;
			// set the element's new position:
			elmnt.style.top =
				elmnt.offsetTop - pos2 > 0 ? elmnt.offsetTop - pos2 + "px" : 0;
			elmnt.style.left =
				elmnt.offsetLeft - pos1 > 0
					? elmnt.offsetLeft - pos1 + "px"
					: 0;

			var maxTop = containerHeight - elementHeight;
			if (elmnt.offsetTop - pos2 > maxTop) {
				elmnt.style.top = maxTop + "px";
			}

			var maxLeft = containerWidth - elementWidth;
			if (elmnt.offsetLeft - pos1 > maxLeft) {
				elmnt.style.left = maxLeft + "px";
			}
		}

		function closeDragElement() {
			/* stop moving when mouse button is released:*/
			document.onmouseup = null;
			document.onmousemove = null;
		}
	}

	$(document).on("click", ".ais-facet-item", function (e) {
		if (
			$(this)
				.find(".ais-refinement-list")
				.hasClass("c-product-filter__menu-item--open")
		) {
			$(this).find(".ais-facet--body").slideUp(500);
			$(this)
				.find(".ais-refinement-list")
				.removeClass("c-product-filter__menu-item--open");
		} else {
			$(".ais-facet--body").slideUp(500);
			$(".ais-refinement-list").removeClass(
				"c-product-filter__menu-item--open"
			);
			$(this).find(".ais-facet--body").slideDown(500);
			$(this)
				.find(".ais-refinement-list")
				.addClass("c-product-filter__menu-item--open");
		}

		// if($(this).hasClass('ais-hierarchical-menu')) {
		//     $(this).toggleClass('c-product-filter__menu-item--open');
		// }

		// let elmClass = e.target.classList.value;
		// if(elmClass.includes('ais-refinement-list--header')) {
		//     if($(this).hasClass('c-product-filter__menu-item--open')) {
		//         $(this).find('.ais-facet--body').slideUp(500);
		//     } else {
		//         $(this).find('.ais-facet--body').slideDown(500);
		//     }
		// }
	});
});

var stickyContainerSelector = ".sticky-container";
var stickyElementSelector = ".sticky-element";
var headerHeight = 132;
var width = $(stickyElementSelector).width() + "px";
var generalContentTabsContainer = $(".general-content-items");

// scrollable section

$(document).ready(function ($) {
	var headerHeight = 133;

	$.fn.StickySidebar = function (options) {
		var defaults = {
			containerSelector: "",
			additionalMarginTop: 0,
			additionalMarginBottom: 0,
			updateSidebarHeight: true,
			minWidth: 0,
			disableOnResponsiveLayouts: true,
			sidebarBehavior: "modern",
		};
		options = $.extend(defaults, options);

		// Validate options
		options.additionalMarginTop =
			parseInt(options.additionalMarginTop) || 0;
		options.additionalMarginBottom =
			parseInt(options.additionalMarginBottom) || 0;

		tryInitOrHookIntoEvents(options, this);

		// Try doing init, otherwise hook into window.resize and document.scroll and try again then.
		function tryInitOrHookIntoEvents(options, $that) {
			var success = tryInit(options, $that);

			if (!success) {
				console.log(
					"TST: Body width smaller than options.minWidth. Init is delayed."
				);

				$(document).scroll(
					(function (options, $that) {
						return function (evt) {
							var success = tryInit(options, $that);

							if (success) {
								$(this).unbind(evt);
							}
						};
					})(options, $that)
				);
				$(window).resize(
					(function (options, $that) {
						return function (evt) {
							var success = tryInit(options, $that);

							if (success) {
								$(this).unbind(evt);
							}
						};
					})(options, $that)
				);
			}
		}

		// Try doing init if proper conditions are met.
		function tryInit(options, $that) {
			if (options.initialized === true) {
				return true;
			}

			if ($("body").width() < options.minWidth) {
				return false;
			}

			init(options, $that);

			return true;
		}

		// Init the sticky sidebar(s).
		function init(options, $that) {
			options.initialized = true;

			// Add CSS
			$("head").append(
				$(
					'<style>.StickySidebar:after {content: ""; display: table; clear: both;}</style>'
				)
			);

			$that.each(function () {
				var o = {};

				o.sidebar = $(this);

				// Save options
				o.options = options || {};

				// Get container
				o.container = $(o.options.containerSelector);
				if (o.container.length == 0) {
					o.container = o.sidebar.parent();
				}

				// Create sticky sidebar
				o.sidebar.parents().css("-webkit-transform", "none"); // Fix for WebKit bug - https://code.google.com/p/chromium/issues/detail?id=20574
				o.sidebar.css({
					position: "relative",
					overflow: "visible",
					// The "box-sizing" must be set to "content-box" because we set a fixed height to this element when the sticky sidebar has a fixed position.
					"-webkit-box-sizing": "border-box",
					"-moz-box-sizing": "border-box",
					"box-sizing": "border-box",
				});

				// Get the sticky sidebar element. If none has been found, then create one.
				o.stickySidebar = o.sidebar.find(".StickySidebar");
				if (o.stickySidebar.length == 0) {
					o.sidebar.find("script").remove(); // Remove <script> tags, otherwise they will be run again on the next line.
					o.stickySidebar = $("<div>")
						.addClass("StickySidebar")
						.append(o.sidebar.children());
					o.sidebar.append(o.stickySidebar);
				}

				// Get existing top and bottom margins and paddings
				o.marginTop = parseInt(o.sidebar.css("margin-top"));
				o.marginBottom = parseInt(o.sidebar.css("margin-bottom"));
				o.paddingTop = parseInt(o.sidebar.css("padding-top"));
				o.paddingBottom = parseInt(o.sidebar.css("padding-bottom"));

				// Add a temporary padding rule to check for collapsable margins.
				var collapsedTopHeight = o.stickySidebar.offset().top;
				var collapsedBottomHeight = o.stickySidebar.outerHeight();
				o.stickySidebar.css("padding-top", 1);
				o.stickySidebar.css("padding-bottom", 1);
				collapsedTopHeight -= o.stickySidebar.offset().top;
				collapsedBottomHeight =
					o.stickySidebar.outerHeight() -
					collapsedBottomHeight -
					collapsedTopHeight;
				if (collapsedTopHeight == 0) {
					o.stickySidebar.css("padding-top", 0);
					o.stickySidebarPaddingTop = 0;
				} else {
					o.stickySidebarPaddingTop = 1;
				}

				if (collapsedBottomHeight == 0) {
					o.stickySidebar.css("padding-bottom", 0);
					o.stickySidebarPaddingBottom = 0;
				} else {
					o.stickySidebarPaddingBottom = 1;
				}

				// We use this to know whether the user is scrolling up or down.
				o.previousScrollTop = null;

				// Scroll top (value) when the sidebar has fixed position.
				o.fixedScrollTop = 0;

				// Set sidebar to default values.
				resetSidebar();

				o.onScroll = function (o) {
					// Stop if the sidebar isn't visible.
					if (!o.stickySidebar.is(":visible")) {
						return;
					}

					// Stop if the window is too small.
					if ($("body").width() < o.options.minWidth) {
						resetSidebar();
						return;
					}

					// Stop if the sidebar width is larger than the container width (e.g. the theme is responsive and the sidebar is now below the content)
					if (o.options.disableOnResponsiveLayouts) {
						var sidebarWidth = o.sidebar.outerWidth(
							o.sidebar.css("float") == "none"
						);

						if (sidebarWidth + 50 > o.container.width()) {
							resetSidebar();
							return;
						}
					}

					var scrollTop = $(document).scrollTop();
					var position = "static";

					// If the user has scrolled down enough for the sidebar to be clipped at the top, then we can consider changing its position.
					if (
						scrollTop >=
						o.container.offset().top +
							(o.paddingTop +
								o.marginTop -
								o.options.additionalMarginTop)
					) {
						// The top and bottom offsets, used in various calculations.
						var offsetTop =
							o.paddingTop +
							o.marginTop +
							options.additionalMarginTop;
						var offsetBottom =
							o.paddingBottom +
							o.marginBottom +
							options.additionalMarginBottom;

						// All top and bottom positions are relative to the window, not to the parent elemnts.
						var containerTop = o.container.offset().top;
						var containerBottom =
							o.container.offset().top +
							getClearedHeight(o.container);

						// The top and bottom offsets relative to the window screen top (zero) and bottom (window height).
						var windowOffsetTop = 0 + options.additionalMarginTop;
						var windowOffsetBottom;

						var sidebarSmallerThanWindow =
							o.stickySidebar.outerHeight() +
								offsetTop +
								offsetBottom <
							$(window).height();
						if (sidebarSmallerThanWindow) {
							windowOffsetBottom =
								windowOffsetTop + o.stickySidebar.outerHeight();
						} else {
							windowOffsetBottom =
								$(window).height() -
								o.marginBottom -
								o.paddingBottom -
								options.additionalMarginBottom;
						}

						var staticLimitTop =
							containerTop -
							scrollTop +
							o.paddingTop +
							o.marginTop;
						var staticLimitBottom =
							containerBottom -
							scrollTop -
							o.paddingBottom -
							o.marginBottom;

						var top = o.stickySidebar.offset().top - scrollTop;
						var scrollTopDiff = o.previousScrollTop - scrollTop;

						// If the sidebar position is fixed, then it won't move up or down by itself. So, we manually adjust the top coordinate.
						if (o.stickySidebar.css("position") == "sticky") {
							if (o.options.sidebarBehavior == "modern") {
								top += scrollTopDiff;
							}
						}

						if (o.options.sidebarBehavior == "stick-to-top") {
							top = options.additionalMarginTop;
						}

						if (o.options.sidebarBehavior == "stick-to-bottom") {
							top =
								windowOffsetBottom -
								o.stickySidebar.outerHeight();
						}

						if (scrollTopDiff > 0) {
							// If the user is scrolling up.
							top = Math.min(top, windowOffsetTop);
						} else {
							// If the user is scrolling down.
							top = Math.max(
								top,
								windowOffsetBottom -
									o.stickySidebar.outerHeight()
							);
						}

						top = Math.max(top, staticLimitTop);

						top = Math.min(
							top,
							staticLimitBottom - o.stickySidebar.outerHeight()
						);

						// If the sidebar is the same height as the container, we won't use fixed positioning.
						var sidebarSameHeightAsContainer =
							o.container.height() ==
							o.stickySidebar.outerHeight();

						if (
							!sidebarSameHeightAsContainer &&
							top == windowOffsetTop
						) {
							position = "sticky";
						} else if (
							!sidebarSameHeightAsContainer &&
							top ==
								windowOffsetBottom -
									o.stickySidebar.outerHeight()
						) {
							position = "sticky";
						} else if (
							scrollTop +
								top -
								o.sidebar.offset().top -
								o.paddingTop <=
							options.additionalMarginTop
						) {
							// Stuck to the top of the page. No special behavior.
							position = "static";
						} else {
							// Stuck to the bottom of the page.
							position = "absolute";
						}
					}

					/*
					 * Performance notice: It's OK to set these CSS values at each resize/scroll, even if they don't change.
					 * It's way slower to first check if the values have changed.
					 */
					if (window.location.pathname == "/cart") {
						var summaryBlockMarging = -10;
						var summaryBlockOffset = 10;
					} else {
						var summaryBlockMarging = 0;
						var summaryBlockOffset = 0;
					}
					if (position == "sticky") {
						o.stickySidebar.css({
							position: "sticky",
							width: o.sidebar.width(),
							top: top,
							left:
								o.sidebar.offset().left +
								parseInt(o.sidebar.css("padding-left")),
							"padding-right": summaryBlockOffset,
						});
					} else if (position == "absolute") {
						var css = {};

						if (o.stickySidebar.css("position") != "absolute") {
							css.position = "absolute";
							css.top =
								scrollTop +
								top -
								o.sidebar.offset().top -
								o.stickySidebarPaddingTop -
								o.stickySidebarPaddingBottom;
						}

						css.width = o.sidebar.width();
						css.left = "";

						o.stickySidebar.css(css);
					} else if (position == "static") {
						resetSidebar();
					}

					if (position != "static") {
						if (o.options.updateSidebarHeight == true) {
							o.sidebar.css({
								"min-height":
									o.stickySidebar.outerHeight() +
									o.stickySidebar.offset().top -
									o.sidebar.offset().top +
									o.paddingBottom,
							});
						}
					}

					o.previousScrollTop = scrollTop;
				};

				// Initialize the sidebar's position.
				o.onScroll(o);

				// Recalculate the sidebar's position on every scroll and resize.
				$(document).scroll(
					(function (o) {
						return function () {
							o.onScroll(o);
						};
					})(o)
				);
				$(window).resize(
					(function (o) {
						return function () {
							o.stickySidebar.css({
								position: "static",
							});
							o.onScroll(o);
						};
					})(o)
				);

				// Reset the sidebar to its default state
				function resetSidebar() {
					o.fixedScrollTop = 0;
					o.sidebar.css({
						"min-height": "1px",
					});
					o.stickySidebar.css({
						position: "static",
						width: "",
					});
				}

				// Get the height of a div as if its floated children were cleared. Note that this function fails if the floats are more than one level deep.
				function getClearedHeight(e) {
					var height = e.height();

					e.children().each(function () {
						height = Math.max(height, $(this).height());
					});

					return height;
				}
			});
		}
	};

	$("#__pf .sticky-element").parent().addClass("sticky-element");
	$("#__pf .part-fixed__fixed").removeClass("sticky-element");

	$(stickyElementSelector).StickySidebar({
		additionalMarginTop: 130,
		additionalMarginBottom: -60,
	});

	$(generalContentTabsContainer).StickySidebar({
		additionalMarginTop: 130,
	});

	$(generalContentTabsContainer).StickySidebar({
		additionalMarginTop: 130,
	});

	$(".summary-block").StickySidebar({
		additionalMarginTop: 135,
	});
});

// scrollable section end

// form validations

$("#RecoverPassword").click(function () {
	$(".signin--text").toggle();
	$(".recover-pass--text").toggle();
});

if( $("#hideRecoverPasswordLink")) {
	$("#HideRecoverPasswordLink").click(function () {
		$(".signin--text").toggle();
		$(".recover-pass--text").toggle();
	});
}

if (
	$("#CustomerEmail").hasClass("input--error") &&
	$("#CustomerPassword").hasClass("input--error")
) {
	$("#CustomerEmail").parent().siblings(".input--error-icon").show();
	$("#CustomerPassword").parent().siblings(".input--error-icon").show();
}
if ($("#RegisterForm-email").hasClass("input--error")) {
	$("#RegisterForm-email").parent().siblings(".input--error-icon").show();
}

function inputFieldValidator(inputFieldId, maxLength) {
	let errorIcon = $(inputFieldId)
		.closest(".input-block")
		.children(".input--error-icon");
	var errorMessageElm = $(inputFieldId).next(".client-errors-msg");
	if (
		$(inputFieldId).val().length <= maxLength ||
		$(inputFieldId).val() == ""
	) {
		errorMessageElm.show();
		errorIcon.show();

		$(inputFieldId).css({
			border: "1px solid rgb(255, 0, 0)",
		});
		return false;
	} else {
		errorMessageElm.hide();
		errorIcon.hide();
		$(inputFieldId).css({
			border: "1px solid transparent",
			"border-bottom-color": "#222",
		});
	}
}

function emailInputValidator(
	inputFieldId,
	emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/
) {
	let errorIcon = $(inputFieldId)
		.closest(".input-block")
		.children(".input--error-icon");
	var errorMessageElm = $(inputFieldId).next(".client-errors-msg");
	$(".reg-errors-msg").hide();
	if (!emailRegex.test($(inputFieldId).val())) {
		errorMessageElm.show();
		errorIcon.show();
		$(inputFieldId).css({
			border: "1px solid rgb(255, 0, 0)",
		});
		return false;
	} else {
		errorMessageElm.hide();
		errorIcon.hide();
		$(inputFieldId).css({
			border: "1px solid transparent",
			"border-bottom-color": "#222",
		});
	}
}

function emailFocusout(inputFieldId) {
	var emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/;
	var errorMessageElm = $(inputFieldId)
		.next(".client-errors-msg")
		.find("span");
	$(".reg-errors-msg").hide();
	if (
		inputFieldId.val().length < 5 &&
		!emailRegex.test($(inputFieldId).val())
	) {
		errorMessageElm.text(`Please enter valid Email address`);
	}
}

function inputFocusout(inputFieldId) {
	var inputLabel = $(inputFieldId).attr("placeholder");
	var errorMessageElm = $(inputFieldId)
		.next(".client-errors-msg")
		.find("span");
	if (inputFieldId.val().length == "") {
		errorMessageElm.text(`${inputLabel} can't be blank`);
	}
}

function inputErrorMessages(inputFieldId, maxLength) {
	var inputLabel = $(inputFieldId).attr("placeholder");
	var errorMessageElm = $(inputFieldId)
		.next(".client-errors-msg")
		.find("span");
	var emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/;
	if ($(inputFieldId).val() == "") {
		errorMessageElm.text(`${inputLabel} can't be blank`);
	} else if ($(inputFieldId).val().length <= maxLength) {
		errorMessageElm.text(
			`${inputLabel} must contains more than ${maxLength} characters`
		);
	} else if (!$(inputFieldId).val().includes("@")) {
		errorMessageElm.text(`${inputLabel} address must contain '@' symbol`);
	} else if (!emailRegex.test($(inputFieldId).val())) {
		errorMessageElm.text(`Please check your Email address`);
	}
}

// login form
// email
$("#CustomerEmail").on("input", function () {
	inputFieldValidator($(this));
	emailInputValidator($(this));
	inputErrorMessages($(this), 5);
});
$("#CustomerEmail").on("focusout", function () {
	emailInputValidator($(this));
	emailFocusout($(this));
	inputFocusout($(this));
});

// recover email
$("#RecoverEmail").on("input", function () {
	inputFieldValidator($(this));
	emailInputValidator($(this));
	inputErrorMessages($(this), 5);
});

$("#RecoverEmail").on("focusout", function () {
	emailInputValidator($(this));
	emailFocusout($(this));
	inputFocusout($(this));
});

// password
$("#CustomerPassword").on("input", function () {
	inputFieldValidator($(this), 4);
	inputErrorMessages($(this), 4);
});

$("#CustomerPassword").on("focusout", function () {
	inputFieldValidator($(this), 4);
	inputFocusout($(this));
});

// signup

var registerFormInputs = function () {
	let emailInput = $("#RegisterForm-email");
	let eventbtn = $("#register");
	let inputValue = $(emailInput).val();
	let emailValidator = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/;
	let emailvalidated = emailValidator.test(inputValue);
	let passInput = $("#RegisterForm-password");
	let passinputValue = $(passInput).val();
	let userFirstName = $("#RegisterForm-FirstName").val();
	let userLastName = $("#RegisterForm-LastName").val();
	if (
		userFirstName.length > 1 &&
		userLastName.length > 1 &&
		emailvalidated &&
		passinputValue.length > 4
	) {
		$("#register").removeClass("button--disabled");
		$(eventbtn).removeAttr("disabled");
		$(emailInput).removeClass("input--error-icon");
		$(emailInput).next(".reg-errors-msg").hide();
	} else {
		$(eventbtn).addClass("button--disabled");
		$(eventbtn).attr("disabled", true);
		$(emailInput).next(".reg-errors-msg").show();
	}
	if (
		$(emailInput).next(".reg-errors-msg").css("display") == "block" &&
		inputValue == ""
	) {
		$(emailInput).addClass("input--error-icon");
	}
};

$("#register").attr("disabled", true);
// firstname

$("#RegisterForm-FirstName").on("input", function () {
	registerFormInputs();
	inputFieldValidator($(this), 1);
	inputErrorMessages($(this), 1);
});

$("#RegisterForm-FirstName").on("focusout", function () {
	inputFieldValidator($(this), 1);
	inputFocusout($(this));
});

// lastname
$("#RegisterForm-LastName").on("input", function () {
	registerFormInputs();
	inputFieldValidator($(this), 1);
	inputErrorMessages($(this), 1);
});

$("#RegisterForm-LastName").on("focusout", function () {
	inputFieldValidator($(this), 1);
	inputFocusout($(this));
});

// email
$("#RegisterForm-email").on("input", function () {
	registerFormInputs();
	inputFieldValidator($(this));
	emailInputValidator($(this));
	inputErrorMessages($(this), 5);
});

$("#RegisterForm-email").on("focusout", function () {
	emailInputValidator($(this));
	emailFocusout($(this));
	inputFocusout($(this));
});

// password
$("#RegisterForm-password").on("input", function () {
	registerFormInputs();
	inputFieldValidator($(this), 4);
	inputErrorMessages($(this), 4);
});

$("#RegisterForm-password").on("focusout", function () {
	inputFieldValidator($(this), 4);
	inputFocusout($(this));
});

// keep me upto date checkbox

/* ====== Vendor Listing page ====== */

// alphabet hover states
$(".o-alphabet__link--active").hover(
	function () {
		$(this)
			.siblings(".o-alphabet__link--active")
			.addClass("make-hoverable");
	},
	function () {
		$(this)
			.siblings(".o-alphabet__link--active")
			.removeClass("make-hoverable");
	}
);

// vendor listing filter fixed position
window.addEventListener("scroll", function () {
	var e = window.pageYOffset || document.documentElement.scrollTop;
	(df = $(".o-vendors-list__filters")), (mf = $(".mobile-vendor-filter"));
	let vendor_container_height = $(".o-vendors-list").height();
	e > 0 && e > 290
		? df.addClass("make_filterbar_sticky")
		: df.removeClass("make_filterbar_sticky");
	e > 0 && e > 250
		? mf.addClass("make_btn_sticky")
		: mf.removeClass("make_btn_sticky");
	if (e > vendor_container_height) {
		mf.removeClass("make_btn_sticky");
	}
});

// category dropdown
var filterAccordion = $(".accordion-item");
var filterAccordionItems = $(".accordion__panel");

$(document).click((e) => {
	if (
		!filterAccordion.is(e.target) && // if the target of the click isn't the container...
		filterAccordionItems.has(e.target).length === 0
	) {
		// ... nor a descendant of the container
		filterAccordionItems.slideUp();
		$(".accordion-item")
			.find(".filter-arrow-down")
			.removeClass("rotate-accordion-icon");
	}
});

$(filterAccordion).on("click", () => {
	filterAccordionItems.slideToggle();
	$(".accordion-item")
		.find(".filter-arrow-down")
		.toggleClass("rotate-accordion-icon");
});

var acc = $(".panel__list__item");
var i;
for (i = 0; i < acc.length; i++) {
	acc[i].addEventListener("click", function () {
		this.classList.toggle("active");
		var panel = this.nextElementSibling;
		if (panel.style.display === "block") {
			$(panel).hide();
		} else {
			$(panel).show();
		}
	});
}

$(".search-close").click(function () {
	$("#vendorListingSearch").val("");
	$(".dropdown-filter .label-text").closest("li").show();
	$(".search-close").hide();
});
$(document).on("input", "#vendorListingSearch", function (e) {
	var searchTerm = e.target.value.toLowerCase();
	var categories = $(".dropdown-filter .label-text");
	if (searchTerm.length > 0) {
		$(".search-close").show();
	} else {
		$(".search-close").hide();
	}
	categories.each(function (_index, category) {
		var categoryName = $(category).text();
		if (categoryName.toLowerCase().includes(searchTerm)) {
			$(category).closest("li").show();
		} else {
			$(category).closest("li").hide();
		}
	});
});

// mobile filter cta btns
function ctaStates(ctaBtnSelector) {
	if (ctaBtnSelector) {
		$("#vendorListClear").removeAttr("disabled");
		$("#vendorListApply").removeAttr("disabled");
	} else {
		$("#vendorListClear").attr("disabled", "disabled");
		$("#vendorListApply").attr("disabled", "disabled");
	}
}

$(".o-vendor-filter-btn").click(function () {
	$(".o-vendors-list__filters").toggleClass("active");
	// $("body").toggleClass("a-overflow");
});

$(".mobile-vendor-close-icon").click(function () {
	$(".o-vendors-list__filters").removeClass("active");
	// $("body").removeClass("a-overflow");
});

// vendor listing filter function
function filtervendors() {
	var vendorItem = $(".o-vendors .o-vendors__item");
	var vendors_first_letter = $(".o-vendors__first__letter");
	var selectedCategories = $("input[name='category']:checked")
		.map(function () {
			return $(this).val().toLowerCase();
		})
		.toArray();

	ctaStates(selectedCategories.length > 0);
	if (selectedCategories.length === 0) {
		vendorItem.show();
		vendors_first_letter.show();
		$('.o-alphabet__link:not(.og-disabled)').removeClass('o-alphabet__link--disabled').addClass('o-alphabet__link--active')
		return;
	}

	// clear all btn
	$("#vendorListClear").click(function (e) {
		e.preventDefault();
		$("#categories label input").prop("checked", false);
		$(".clear-all--btn a").attr("disabled", "disabled");
		vendorItem.show();
	});

	// apply btn
	$("#vendorListApply").click(function () {
		$(".o-vendors-list__filters").removeClass("active");
		$("body").removeClass("a-overflow");
		$("html, body").animate(
			{
				scrollTop: 0,
			},
			1000
		);
	});

	vendors_first_letter.hide();
	$('.o-alphabet__link').addClass('o-alphabet__link--disabled').removeClass('o-alphabet__link--active');

	vendorItem.each(function (_index, tile) {

		var category = $(this)
			.find(".o-vendors__link")
			.data("category")
			.split(" ");

		category = category.filter(Boolean);

		// console.log('xxx');
		// console.log(tile);
		// console.log(category);

		if (category.some((r) => selectedCategories.includes(r))) {
			$(tile).show();
		} else {
			$(tile).hide();
		}

		if ($(tile).css("display") == "block") {
			let showLetter = $(tile)
				.closest(".o-vendors__row")
				.prev(".o-vendors__first__letter");
			showLetter.show();
			let letterID = showLetter.attr('id');
			$('.o-alphabet__link[href="#'+letterID+'"]').removeClass('o-alphabet__link--disabled').addClass('o-alphabet__link--active');
		}

	});
}

$(".dropdown-filter .accordion__panel__list label").click(function () {
	filtervendors();
	$("html, body").animate(
		{
			scrollTop: 0,
		},
		300
	);
});

// for proper scroll on select(alphabet link hashes)
$('a[href*="#"]')
	// Remove links that don't actually link to anything
	.not('[href="#"]')
	.not('[href="#0"]')
	.click(function (event) {
		// On-page links
		if (
			location.pathname.replace(/^\//, "") ==
				this.pathname.replace(/^\//, "") &&
			location.hostname == this.hostname
		) {
			// Figure out element to scroll to
			var target = $(this.hash);
			target = target.length
				? target
				: $("[name=" + this.hash.slice(1) + "]");
			// Does a scroll target exist?
			$("body").removeClass("a-overflow");
			$(".o-vendors-list__filters").removeClass("active");
			var gcPageContainer = $(".general-content-page");
			if (gcPageContainer.css("display") == "block") {
				var gcPageContainerOffsetTop = 60;
			} else {
				var gcPageContainerOffsetTop = 0;
			}
			var listingFiltersHeight = 200;
			if ($(".o-vendor-filter-btn").css("display") == "block") {
				listingFiltersHeight = 140; // mobile vendor item filters height
			}
			// console.log(target);
			if (target.length) {
				// Only prevent default if animation is actually gonna happen
				event.preventDefault();
				if (target.selector == "#vendor_numbers") {
					$("html, body").animate(
						{
							scrollTop: 292,
						},
						1000
					);
				} else {
					$("html, body").animate(
						{
							scrollTop:
								target.offset().top +
								gcPageContainerOffsetTop -
								listingFiltersHeight,
						},
						1000
					);
				}
			}
		}
	});
/* ====== Vendor Listing page end ====== */

/* ====== Footer links ====== */

$(".c-menu__link--dropdown .c-menu__link--dropdown-item").click(function () {
	let parentElm = $(this).closest(".c-menu__link--dropdown");
	parentElm.toggleClass("open");
	parentElm.find(".c-menu__link--dropdown-menu").slideToggle(200);
});

/* ====== Footer Links end ====== */
/* ====== general-content Item tabs ====== */
$(".general-content-items ul li a").click(function () {
	let tab_id = $(this).attr("data-tab");
	$(".general-content-items ul a").removeClass("current");
	$(".item-content").removeClass("current");

	$(this).addClass("current");
	$("#" + tab_id).addClass("current");
});

/* ====== general-content Item tabs end ====== */

/* ====== Video Loader Func ====== */

var videoLoader = function (videoLoaderElm) {
	var video = $(videoLoaderElm);
	if (video.is(":visible")) {
		$("source", video).each(function () {
			const el = $(this);
			el.attr("src", el.data("src"));
		});
		video.each(function (_index, element) {
			element.load();
		});
	}
};

/* ====== Hero Banner Video ====== */

videoLoader(".desktop_video_banner");
videoLoader(".mobile_video_banner");

/* ====== Currency Dropdown  ====== */

$(".currency-dropdown-menu a").each(function () {
	let currencyCode = $(this)
		.find(".currency-dropdown-item--text")
		.text()
		.split(" ");
	let currenntURL = window.location.href.split("?")[0];
	$(this).attr("data-href", `${currenntURL}?currency=${currencyCode[0]}`);
	$(this).attr("href", "javascript:void(0)");
});

$(".current-store-currency").on("click", function () {
	$(this).toggleClass("currency-dropdown-menu--opened");
	$(".currency-dropdown-menu").toggleClass("currency-dropdown-menu--closed");
});

$(".currency-dropdown-menu a").on("click", function () {
	let currencyUrl = $(this).attr("data-href");
	if (window.location.href != currencyUrl) {
		let currencyCode = $(this).find(".currency-dropdown-item--text").text();
		$(".current-store-currency")
			.find(".currency-dropdown-item--text")
			.text(currencyCode);
		$(".current-store-currency").toggleClass(
			"currency-dropdown-menu--opened"
		);
		$(".currency-dropdown-menu").toggleClass(
			"currency-dropdown-menu--closed"
		);
		window.history.pushState({ currencyUrl: currencyUrl }, "", currencyUrl);
		location.reload();
	}
});

/* ====== Mini Cart Bottom Cotainer position   ====== */

let cartDrawerItemCounter = function () {
	if ($(".cart-items__item").length > 2) {
		$(".cart-drawer__bottom").removeClass("r-margin");
	} else {
		$(".cart-drawer__bottom").addClass("r-margin");
	}
};

cartDrawerItemCounter();

$(".o-cart-counter").click(cartDrawerItemCounter);

/* ====== lazy Loading ====== */

const images = document.querySelectorAll("[data-src]");

function preloadImage(img) {
	const src = img.getAttribute("data-src");
	if (!src) {
		return;
	}
	img.src = src;
}

const imgOptions = {
	threshold: 0,
	rootMargin: "0px 0px 500px 0px",
};

const imgObserver = new IntersectionObserver((entries, imgObserver) => {
	entries.forEach((entry) => {
		if (!entry.isIntersecting) {
			return;
		} else {
			preloadImage(entry.target);
			imgObserver.unobserve(entry.target);
		}
	});
}, imgOptions);

images.forEach((image) => {
	imgObserver.observe(image);
});

function getCookie(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}
let recentlyViewdCookies = getCookie("shopify_recently_viewed").split(" ");
// console.log(recentlyViewdCookies);
if (recentlyViewdCookies.length > 4) {
	$(".alternate-product-carousel").removeClass("inactive");
	$(".alternate-product-carousel").removeClass("js-inactive");
} else {
	$(".selectable-products-carousel").removeClass("inactive");
}

if (recentlyViewdCookies == "") {
	$(".on-gift-card-template").hide();
}

/* ====== Quick Announcement Banner ====== */

// function paddingForQaBanner() {
//     $('header').addClass('has-announcement-bar');
//     var qaBanner = $('#qab_container').html();
//     $('header').prepend(qaBanner);
//     $('#qab_container').hide();

//     mobileNavPosition()

//     if($(document).width() < 1025) {
//         var QaBannerHeight = $('#qab_background').height();
//         var headerHeight = $('header .l-wrap').outerHeight();
//         $('#main').css('padding-top', `${QaBannerHeight + headerHeight}px`);
//     }

//     $('#qab_close').on( "click", function(){
//         $('header').removeClass('has-announcement-bar');
//         if($(document).width() < 1025) {
//             $('#main').css('padding-top',  `${headerHeight}px`);
//         }
//         mobileNavPosition();
//     })
// }

// var QaBannerTimer = 1;
// function isQaBannerSticky() {
//     if($('#qab_background').css('position') == 'fixed') {
//         paddingForQaBanner();
//     } else if(QaBannerTimer < 20) {
//         setTimeout(isQaBannerSticky, 1000);
//         QaBannerTimer++;
//     }
// }

// document.addEventListener('readystatechange', function() {
//     if(document.readyState == 'complete') {
//         isQaBannerSticky();
//     }
// });

/* ====== End Quick Announcement Banner ====== */

/* ====== if product are not available in STL module  ====== */

var numberOfStlAvailableProduct = [];
$(".stl_available_product").map(function () {
	numberOfStlAvailableProduct.push($(this));
});

if (numberOfStlAvailableProduct.length == 0) {
	$(".shop-the-look").hide();
}

/* ====== End STL module ====== */

/* ====== Sort By filter on Collection Page  ====== */

let sortByDropdownItem = $(".c-dropdown__item--sort-by");

sortByDropdownItem.on("click", function (e) {
	e.preventDefault();
	var params = new URLSearchParams(window.location.search.slice(1));
	let baseURL = window.location.href.split("?")[0];
	params.set($(this).attr("data-name"), $(this).attr("href"));
	window.location.href = `${baseURL}?${params.toString()}`;
});

/* ====== White Overlay for loading State ====== */

document.addEventListener("DOMContentLoaded", function () {
	let pageContainer = $(".l-page");
	let pageOverlayText = $(".l-page__overlay-text");
	setTimeout(function () {
		if (pageContainer[0]) {
			pageContainer[0].addClass("l-page--loaded");
			$(body).addClass("l-page-content--loaded");
			pageOverlayText[0].remove();
			$("#l-page__overlay-text-style").remove();
		}
	}, 2000);
});

/* ====== Address Form ====== */

let addressFormContainer = $("#AddressNewForm");

addressFormContainer.length &&
	Shopify &&
	new Shopify.CountryProvinceSelector(
		"AddressCountryNew",
		"AddressProvinceNew",
		{
			hideElement: "AddressProvinceContainerNew",
		}
	);

$(".address-country-option").each(function () {
	// console.log(this);
	let countryOptionFormId = $(this).data("form-id");
	let addressCountryId = "AddressCountry_" + countryOptionFormId;
	let addressProvinceId = "AddressProvince_" + countryOptionFormId;
	let addressProvinceContainer =
		"AddressProvinceContainer_" + countryOptionFormId;
	new Shopify.CountryProvinceSelector(addressCountryId, addressProvinceId, {
		hideElement: addressProvinceContainer,
	});
});

$(".address-new-toggle").on("click", function () {
	addressFormContainer.toggleClass("u-hide");
});

$(".address-edit-toggle").on("click", function () {
	let addressEditToggle = $(this).data("form-id");
	$("#EditAddress_" + addressEditToggle).toggleClass("u-hide");
});

$(".address-delete").on("click", function () {
	var addressDeleteElmFormId = $(this).data("form-id");
	var addressDeleteElmMsg = $(this).data("confirm-message");
	window.confirm(
		addressDeleteElmMsg || "Are you sure you wish to delete this address?"
	) &&
		Shopify.postLink("/account/addresses/" + addressDeleteElmFormId, {
			parameters: {
				_method: "delete",
			},
		});
});

/* ====== Recover Password Container ====== */

function toggleRecoverPasswordContainer() {
	$("#RecoverPasswordForm").toggleClass("u-hide");
	$("#CustomerLoginForm").toggleClass("u-hide");
	$("#ResetSuccess").addClass("u-hide");
}

$("#RecoverPassword").length &&
	"#recover" === window.location.hash &&
	toggleRecoverPasswordContainer();

$(".reset-password-success").length && $("#ResetSuccess").removeClass("u-hide");

$("#RecoverPassword").on("click", function (e) {
	e.preventDefault();
	toggleRecoverPasswordContainer();
});

if( $("#hideRecoverPasswordLink") ) {
	$("#HideRecoverPasswordLink").on("click", function (e) {
		e.preventDefault();
		toggleRecoverPasswordContainer();
	});
}

/* ====== Navbar and Sidenav ====== */

// let menuToggleElm = $('.menuToggle');
// let lPageContainer = $('.l-page');
// let mobileMenuContainer = $('.o-mobile-menu');

// window.addEventListener("scroll", function () {
//     let pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
//     let headerContainer = document.getElementsByClassName("l-header")[0];

//     pageYOffset > 0 && pageYOffset > 250 ?
//     headerContainer.classList.add("l-header--scrolled") :
//     headerContainer.classList.remove("l-header--scrolled");
// });

// $(menuToggleElm).on('click', function (e) {
//     e.preventDefault();

//     $(this).toggleClass('o-menu-toggle--open');
//     $('body').toggleClass('o-body--menu-active');

//     lPageContainer.toggleClass('l-page--menu-active');
//     mobileMenuContainer.toggleClass('o-mobile-menu--open');
// });

$("body").on("click", ".l-page__overlay", function (e) {
	menuToggleElm.trigger("click");
	$(document).find('.product-card-plus.active').trigger('click');
});

/* ====== Product Image Zoom on PDP ====== */

function mousePoiterPosition(event, targetContainer) {
	if (
		$(targetContainer).hasClass("o-zoom--is-active") &&
		$(window).width() > 1024
	) {
		let horizontalPosition,
			verticalPosition,
			targetElm = event.currentTarget;
		let imgWidth = void 0;
		let imgHeight = void 0;
		imgWidth = event.offsetX ? event.offsetX : event.touches[0].pageX;
		event.offsetY
			? (imgHeight = event.offsetY)
			: (imgWidth = event.touches[0].pageX);
		(horizontalPosition = (imgWidth / targetElm.offsetWidth) * 100),
			(verticalPosition = (imgHeight / targetElm.offsetHeight) * 100);
		targetElm.style.backgroundPosition =
			horizontalPosition + "% " + verticalPosition + "%";
	}
}

$("body").on("click", ".js-zoom", function (e) {
	$(window).width() > 1024 &&
		($(this).toggleClass("o-zoom--is-active").toggleClass("o-zoom--load"),
		mousePoiterPosition(e, this));
});

$(".js-zoom").mousemove(function (e) {
	$(window).width() > 1024 &&
		($(this).hasClass("o-zoom--load") ||
			$(".js-zoom").each(function () {
				$(this).css(
					"background-image",
					"url(" + $(this).attr("data-zoom") + ")"
				);
			}),
		mousePoiterPosition(e, this));
});

$(".js-zoom").mouseout(function () {
	$(this).removeClass("o-zoom--is-active");
});

/* ====== PDP Clicking on thumbnail should scroll to image ===== */

$(".slider--thumbnails [data-nav]").click(function (e) {
	e.preventDefault();
	//Set Offset Distance from top to account for fixed nav
	var offset = 95;
	var targetIndex = $(this).data("nav");
	var target = $(
		".o-single-product__images-container .o-slider__item" +
			'[data-nav="' +
			targetIndex +
			'"]'
	);
	var $target = $(target);
	//Animate the scroll to, include easing lib if you want more fancypants easings
	$("html, body")
		.stop()
		.animate(
			{
				scrollTop: $target.offset().top - offset,
			},
			800,
			"swing"
		);


		if ($(document).find('.bcpo-medium-swatches').length) {
			$('.o-single-product__images-container').slick('slickGoTo', targetIndex);
		}

});

/* ====== PDP Accordions ====== */

$("body").on("click", ".o-accordion__link--toggle", function (e) {
	e.preventDefault();
	var $accordionItems = $(".o-accordion__content-wrapper");
	let selectedAccordionItem = $(this).parents(".o-accordion__item");
	let accordionContentWrapper = selectedAccordionItem.find(
		".o-accordion__content-wrapper"
	);
	if (selectedAccordionItem.hasClass("o-accordion__item--open")) {
		accordionContentWrapper.slideUp(500);
		selectedAccordionItem.removeClass("o-accordion__item--open");
	} else {
		$(".o-accordion__item").removeClass("o-accordion__item--open");
		$accordionItems.slideUp(500);
		accordionContentWrapper.slideDown(500);
		selectedAccordionItem.addClass("o-accordion__item--open");
	}
});

/* ====== Dropdown Toggler(Sort By DropDown, Product DropDown, Gift Card Variant Dropdown, etc. ) ====== */

$("body").on("click", ".c-dropdown__toggle", function (e) {
	e.preventDefault();
	let cDropdownElm = $(this).parents(".c-dropdown");
	let cDropdownMenu = cDropdownElm.find(".c-dropdown__menu");
	if (cDropdownElm.hasClass("c-dropdown--open"))
		cDropdownMenu.slideToggle(500),
			cDropdownElm.removeClass("c-dropdown--open");
	else {
		var n = $(".c-dropdown--open");
		n.length > 0 &&
			(n.find(".c-dropdown__menu").slideToggle(500),
			n.removeClass("c-dropdown--open")),
			cDropdownMenu.slideToggle(500),
			cDropdownElm.addClass("c-dropdown--open");
	}
});

/* ====== Dropdown Text (Product Size DropDown on PDP and Gift Card Variant Dropdown ) ====== */

$("body").on("click", ".js-dropdown__item", function () {
	var dropdownItemText = $(this).text();
	$(this)
		.parents(".c-dropdown")
		.find(".c-dropdown__toggle-text")
		.text(dropdownItemText);
});

/* ====== Animated Block (White Overlay) ====== */

$(document).ready(function () {
	let animatedBlockElms = [];

	let removeAnimatedWhiteOverlayOnPageLoad = function () {
		if (animatedBlockElms.length) {
			for (
				var elmPosition = $(window).scrollTop() + $(window).height(),
					elm = 0;
				elm < animatedBlockElms.length;
				elm++
			) {
				elmPosition + animatedBlockElms[elm].scroll_offset >
					animatedBlockElms[elm].element.offset().top &&
					animatedBlockElms[elm].element.addClass(
						"o-animated-block--visible"
					);
			}
		}
	};

	$(".o-animated-block").each(function () {
		$(this).hasClass("o-animated-block--visible") ||
			animatedBlockElms.push({
				element: $(this),
				scroll_offset: 0,
			});
	});
	removeAnimatedWhiteOverlayOnPageLoad();
	$(window).scroll(function () {
		removeAnimatedWhiteOverlayOnPageLoad();
	});
});

/* ====== Data Responsive Background Image for Banners ====== */

let responsiveBackgroundImgs = $("[data-responsive-background-image]");
responsiveBackgroundImgs.each(function (backgroundImg) {
	let responsiveBgElm = $(this);
	let imgElm = $(this).find("img");
	let imgElmSrc = imgElm.attr("src");
	// console.log(responsiveBgElm + "   " + imgElmSrc);
	responsiveBgElm.css("background-image", `url(${imgElmSrc})`);
});

/* ====== Product Add to Cart Operations ====== */

let cartAttrObj = {
	addToCart: "[data-add-to-cart]",
	addToCartAjax: "[data-add-to-cart-ajax]",
	addToCartText: "[data-add-to-cart-text]",
	productQty: "[data-product-qty]",
	comparePrice: "[data-compare-price]",
	comparePriceWrapper: ".o-single-product__price--compare",
	originalSelectorId: "[data-product-select]",
	priceWrapper: "[data-price-wrapper]",
	productJson: "[data-product-json]",
	productPrice: "[data-product-price]",
	singleOptionSelector: "[data-single-option-selector]",
	formAddTOCart: "[data-form-add-to-cart]",
	singleOptionSelectorFields: "[data-single-option-selector-field]",
	formNotify: ".o-single-product__form--notify",
	cartMini: "[data-cart-mini]",
	cartMiniText: "[data-cart-mini-text]",
	singleOptionDropdown: "[data-single-option-dropdown]"
};

function isVariantChanged(variant, currentElm) {
	let addToCart = currentElm.find(cartAttrObj.addToCart);
	let addToCartText = currentElm.find(cartAttrObj.addToCartText);
	let formNotify = $(cartAttrObj.formNotify);
	if (variant != void 0 || variant != null) {
		// console.log(variant);
		var selected =
			$(cartAttrObj)
				.find('[data-id="size-dropdown"]')
				.find(".c-dropdown__item--active").length > 0;
		if (
			$(cartAttrObj).find('[data-id="size-dropdown"]').length > 0 &&
			!selected
		) {
			return;
		}
		variant.available
			? (addToCart.removeAttr("disabled"),
			  addToCartText.html(window.theme.strings.addToCart),
			  1 === formNotify.find("[data-notify-success]").length
					? formNotify.removeClass("u-hide")
					: formNotify.addClass("u-hide"))
			: (addToCart.attr("disabled", "disabled"),
			  addToCartText.html(window.theme.strings.soldOut));
		let comparePriceElm = currentElm.find(cartAttrObj.comparePrice);
		let productPriceElm = currentElm.find(cartAttrObj.productPrice);
		let comparePriceWrapper = currentElm.find(
			cartAttrObj.comparePriceWrapper
		);
		// console.log(Shopify);
		productPriceElm.html(
			Shopify.customFormatMoney(variant.price, Shopify.money_format)
			// variant.price
		);
		variant.compare_at_price > variant.price
			? (comparePriceElm.html(
					Shopify.customFormatMoney(
						variant.compare_at_price,
						Shopify.money_format
					)
			  ),
			  comparePriceWrapper.removeClass("u-hide"))
			: (comparePriceElm.html(""),
			  comparePriceWrapper.addClass("u-hide"));
	}
	if ($(".klaviyo-bis-trigger").length > 0) {
		if (variant && variant.available) {
			$(
				".o-single-product .o-single-product__variant-container .o-product__badge"
			).hasClass("o-product__badge--coming-soon")
				? $(".klaviyo-bis-trigger").show()
				: $(".klaviyo-bis-trigger").hide(); // hide the button
		} else {
			$(".klaviyo-bis-trigger")
				.show()
				.attr("data-variant-id", variant.id); // show the button and set the default variant
		}
	}
}


function toggelVariant(elm) {
	let container = elm;
	// if( elm.find(cartAttrObj.productJson).html() ) {

		let product = JSON.parse(elm.find(cartAttrObj.productJson).html());
		let optionSelector = elm.find(
			"[data-single-option-selector]:not(.o-single-product__variant-size--single)"
		);
		let productOptions = {};
		optionSelector.on("change", function () {
			/* Code for select dropdown

			// optionSelector.each(function(index, selector) {
			//     productOptions[$(selector).data('index')] = ($(selector).val());
			// });
			// let selectedVariant = product.variants.filter(function(variant) {
			//     return Object.keys(productOptions).every(function(option) {
			//         return variant[option] === productOptions[option]
			//     });
			// })[0];
			if(!!selectedVariant) {
				container.find(cartAttrObj.originalSelectorId).val(selectedVariant.id);
				container.trigger("variantChange", selectedVariant);
			}

			*/
			var selectedVariantId = $(
				".o-single-product__size-selector input[name='id']:checked"
			).val();
			var selectedVariant = product.variants.filter(function (variant) {
				return variant.id.toString() === selectedVariantId;
			});

			// data-product-select should be updated for Klaviyo BIS to work properly
			if (selectedVariantId) {
				$("[data-product-select]").val(selectedVariantId);
			}

			container.trigger("variantChange", selectedVariant[0]);
		});
		elm.on("variantChange", function (e, variant) {
			isVariantChanged(variant, container);
		});
		optionSelector.trigger("change");
		elm.attr("data-change-listener-attached", "true");
	// }
}

// for suggested products carousel and algolia helpers

function initProductTiles(productData) {
	$('.o-product--list-item:not([data-change-listener-attached="true"])').each(
		function () {
			var container = $(this);
			var product;
			if (productData) {
				product = productData;
			} else {
				if ($(this).find(cartAttrObj.productJson).length > 0) {
					product = JSON.parse(
						$(this).find(cartAttrObj.productJson).html()
					);
				} else {
					return;
				}
			}
			var optionSelector = $(this).find("[data-single-option-selector]");
			var productOptions = {};
			optionSelector.on("change", function () {
				optionSelector.each(function (index, selector) {
					productOptions[$(selector).data("index")] =
						$(selector).val();
				});
				var selectedVariant = product.variants.filter(function (
					variant
				) {
					return Object.keys(productOptions).every(function (option) {
						return variant[option] === productOptions[option];
					});
					// return variant.option1 === productOptions[0] && variant.option2 === productOptions[1];
				})[0];
				if (!!selectedVariant) {
					container
						.find(cartAttrObj.originalSelectorId)
						.val(selectedVariant.id);
					container.trigger("variantChange", selectedVariant);
				}
			});
			$(this).on("variantChange", function (e, variant) {
				isVariantChanged(variant, container);
			});
			optionSelector.trigger("change");
			$(this).attr("data-change-listener-attached", "true");
		}
	);
}

$(".o-product--list-item").each(function () {
	toggelVariant($(this));
});

$(".o-single-product .o-single-product__variant-container").each(function () {
	toggelVariant($(this));
	$("body").on(
		"change",
		cartAttrObj.singleOptionSelectorFields,
		function (e) {
			$(cartAttrObj.singleOptionSelectorFields).removeAttr("checked");
			$(this).attr("checked", "checked");
			let currentElmValue = $(this).val();
			let dataSelectattr = $(this).attr("data-select");
			$(dataSelectattr).val(currentElmValue).trigger("change");
		}
	);
});

$("body").on("change", cartAttrObj.productQty, function () {
	let addTOCartFormElm = $(this).parents(cartAttrObj.formAddTOCart);
	let addToCartElm = addTOCartFormElm.find(cartAttrObj.addToCart);
	let addToCartText = addTOCartFormElm.find(cartAttrObj.addToCartText);
	addToCartElm.is(":disabled") ||
		addToCartText.html(window.theme.strings.addToCart);
});

$("body").on("click", cartAttrObj.singleOptionDropdown, function (e) {
	e.preventDefault();
	$(this)
		.parents(".c-dropdown")
		.find(".c-dropdown__item")
		.removeClass("c-dropdown__item--active");
	$(this).addClass("c-dropdown__item--active");
	let currentElmId = $(this).attr("data-id");
	$(currentElmId).val($(this).attr("data-value")).trigger("change");
	$(this).parents(".c-dropdown").find(".c-dropdown__toggle").trigger("click");
});


$("body").on("click", cartAttrObj.addToCartAjax, function (e) {
	e.preventDefault();
	let addTOCartForm = $(this).parents(cartAttrObj.formAddTOCart);
	let currentElm = $(this);
	currentElm.addClass("c-button--loading"),
		$.ajax({
			type: "POST",
			url: "/cart/add.js",
			dataType: "json",
			data: addTOCartForm.serialize(),
		})
			.done(function (e) {
				$.getJSON("/cart.js", function (e) {
					cartActions.renderCart(e);
					e.item_count > 0
						? ($(cartAttrObj.cartMini).addClass(
								"o-cart-link--full"
						  ),
						  $(cartAttrObj.cartMiniText)
								.html(e.item_count)
								.removeClass("u-hide"),
						  $(".k-menu__shopping-bag").removeClass("bag-empty"),
						  e.item_count > 9
								? ($(".k-menu__shopping-bag").addClass(
										"bag-full"
								  ),
								  $(".k-menu__shopping-bag").removeClass(
										"bag-filled"
								  ))
								: ($(".k-menu__shopping-bag").addClass(
										"bag-filled"
								  ),
								  $(".k-menu__shopping-bag").removeClass(
										"bag-full"
								  )),
						  $(".cart-items-container").addClass(
								"shopping-bag-filled"
						  ),
						  $(".cart-items-container").removeClass(
								"shopping-bag-empty"
						  ))
						: ($(cartAttrObj.cartMiniText)
								.html(e.item_count)
								.addClass("u-hide"),
						  $(cartAttrObj.cartMini).removeClass(
								"o-cart-link--full"
						  ),
						  $(".k-menu__shopping-bag").addClass("bag-empty"),
						  $(".k-menu__shopping-bag").removeClass("bag-full"),
						  $(".k-menu__shopping-bag").removeClass("bag-filled"),
						  $(".cart-items-container").removeClass(
								"shopping-bag-filled"
						  ),
						  $(".cart-items-container").addClass(
								"shopping-bag-empty"
						  )),
						currentElm.removeClass("c-button--loading");

						// if ($(window).width() < 768) {

							$(".cart-drawer-overlay").addClass("open");
							$(".cart-drawer").addClass("cart-drawer--open");
							$("body").addClass("noscroll");

						// }

						if ($(".cart-items__item").length > 2) {
							$(".cart-drawer__bottom").removeClass("r-margin");
						} else {
							$(".cart-drawer__bottom").addClass("r-margin");
						}

						$(".c-product-tile__variant-size__container").removeClass(
							"show-button"
						);

				}),
					currentElm.addClass("c-button--loading"),
					currentElm
						.find(cartAttrObj.addToCartText)
						.html(window.theme.strings.addedToBag),
					setTimeout(function () {
						currentElm
							.find(cartAttrObj.addToCartText)
							.html(window.theme.strings.addToCart);
					}, 3000);
				addTOCartForm.find(".error").remove();
			})
			.fail(function (e, o) {
				var errorMessage = "Error";
				var errorType = e.responseJSON.message;
				if (errorType === "Parameter Missing or Invalid") {
					errorMessage = "Please Select A Size";
				} else if (errorType === "Cart Error") {
					errorMessage = "Could not add item to bag";
				}
				// console.log("Error", errorMessage);
				// console.log(addTOCartForm.has(".error"));
				if (addTOCartForm.find(".error").length > 0) {
					addTOCartForm.find(".error").text(errorMessage);
				} else {
					// console.log("ELSE");
					addTOCartForm.append(
						"<p class='error' style='position: absolute'>" +
							errorMessage +
							"</p>"
					);
					setTimeout(function () {
						addTOCartForm.find(".error").remove();
					}, 3000);
				}
				currentElm.removeClass("c-button--loading");
			});
});

/* ====== Pdp page Dropdown  ====== */

if (
	$(".o-single-product .c-dropdown__menu .c-dropdown__item").length > 1 &&
	$(".c-dropdown__toggle").text().trim() != "One"
) {
	$(".o-single-product__form #add-to-cart").attr("disabled", "disabled");
}

/* ====== Cart Page and Mini Cart  ====== */

var cartObj = {
	cartQty: "[data-cart-qty]",
	cartRemove: "[data-cart-remove]",
	cartItem: "[data-cart-item]",
	cart: "[data-cart]",
	cartMini: "[data-cart-mini]",
	cartMiniText: "[data-cart-mini-text]",
	cartItemPrice: "[data-cart-item-original-price]",
	cartItemDiscount: "[data-cart-item-original-dscount]",
	cartSubtotal: "[data-cart-subtotal]",
	cartSubtotalDiscount: "[data-cart-subtotal-discounts]",
	cartTotal: "[data-cart-total]",
	cartEmpty: "[data-cart-empty]",
};

function updateMiniCart(e) {
	e > 0
		? ($(cartObj.cartMini).addClass("o-cart-link--full"),
		  $(cartObj.cartMiniText).html(e).removeClass("u-hide"))
		: ($(cartObj.cartMiniText).html(e).addClass("u-hide"),
		  $(cartObj.cartMini).removeClass("o-cart-link--full"));
}

function updateCart(e) {

	e.item_count > 0
		? ($(".k-menu__shopping-bag").removeClass("bag-empty"),
		  e.item_count > 9
				? ($(".k-menu__shopping-bag").addClass("bag-full"),
				  $(".k-menu__shopping-bag").removeClass("bag-filled"))
				: ($(".k-menu__shopping-bag").removeClass("bag-full"),
				  $(".k-menu__shopping-bag").addClass("bag-filled")),
		  $(".cart-items-container").removeClass("shopping-bag-empty"),
		  $(".cart-items-container").addClass("shopping-bag-filled"))
		: ($(".k-menu__shopping-bag").addClass("bag-empty"),
		  $(".cart-items-container").addClass("shopping-bag-empty"),
		  $(".cart-items-container").removeClass("shopping-bag-filled"));
	e.item_count > 0
		? (updateMiniCart(e.item_count),
		  e.items.forEach(function (e) {
				$(cartObj.cart)
					.find('[data-id="' + e.variant_id + '"]')
					.find(cartObj.cartItemPrice)
					.html(
						Shopify.customFormatMoney(
							e.original_line_price,
							Shopify.money_format
						)
					);
		  }),
		  $(cartObj.cartSubtotal).html(
				Shopify.customFormatMoney(
					e.original_total_price,
					Shopify.money_format
				)
		  ),
		  $(cartObj.cartTotal).html(
				Shopify.customFormatMoney(
					e.original_total_price,
					Shopify.money_format
				)
		  ))
		: (updateMiniCart(e.item_count),
		  $(cartObj.cartEmpty).removeClass("u-hide"),
		  $(cartObj.cart).remove());


		  e.total_price > 20000 ? $('#shipping-cost-message').html('Free Shipping') : $('#shipping-cost-message').html('Shipping calculated at checkout');

}

$(cartObj.cartRemove).on("click", function (e) {
	if ((e.preventDefault(), !$(this).hasClass("c-link--disabled"))) {
		$(this).addClass("c-link--disabled");
		let item = $(this).parents(cartObj.cartItem);
		let id = item.data("id");
		let params = {
			type: "POST",
			url: "/cart/change.js",
			data: "quantity=0&id=" + id,
			dataType: "json",
			success: function (e) {
				cartActions.renderCart(e);
				updateCart(e), item.remove();
			},
			error: function error(XMLHttpRequest) {
				var data = eval("(" + XMLHttpRequest.responseText + ")");
				data.message
					? console.log(
							data.message +
								"(" +
								data.status +
								"): " +
								data.description
					  )
					: console.log(
							"Error : " +
								Shopify.fullMessagesFromErrors(data).join(
									"; "
								) +
								"."
					  );
			},
		};
		$.ajax(params);
	}
});

$(cartObj.cartQty).on("change", function () {
	let item = $(this).parents(cartObj.cartItem);
	let id = item.data("id");
	let quantity = parseInt($(this).val(), 10);
	let changes = {
		id: id,
		quantity: quantity,
	};
	let params = {
		type: "POST",
		url: "/cart/change.js",
		dataType: "json",
		data: changes,
		success: function (e) {
			updateCart(e);
		},
		error: function error() {
			var data = eval("(" + XMLHttpRequest.responseText + ")");
			data.message
				? console.log(
						data.message +
							"(" +
							data.status +
							"): " +
							data.description
				  )
				: console.log(
						"Error : " +
							Shopify.fullMessagesFromErrors(data).join("; ") +
							"."
				  );
		},
	};
	$.ajax(params);
});

// /* ====== Product Images Carousel on PDP  ====== */
// // console.log("TESTESTEST");
// $(document).ready(function () {
// 	// setTimeout(function () {
// 	$(".slider--simple").slick({
// 		slidesToShow: 1,
// 		slidesToScroll: 1,
// 		arrows: false,
// 		asNavFor: ".slider--thumbnails",
// 		responsive: [
// 			{
// 				breakpoint: 1024,
// 				settings: {
// 					infinite: true,
// 					dots: true,
// 				},
// 			},
// 		],
// 	});

// 	// $('.slider--thumbnails').slick({
// 	//     slidesToShow: 4,
// 	//     slidesToScroll: 1,
// 	//     asNavFor: '.slider--simple',
// 	//     focusOnSelect: true,
// 	//     vertical: true,
// 	//     prevArrow: $('.thumbs_arrow--left'),
// 	//     nextArrow: $('.thumbs_arrow--right'),
// 	//     arrows: true
// 	// });

// 	// Product Detail Page Mobile Carousel slide Indicator

// 	var $status = $(".o-single-product__sliders__paging-info");
// 	var $productDetailMobileCarousel = $(".o-single-product__images-container");

// 	$productDetailMobileCarousel.on(
// 		"init reInit afterChange",
// 		function (event, slick, currentSlide, nextSlide) {
// 			//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
// 			var i = (currentSlide ? currentSlide : 0) + 1;
// 			$status.text("0" + i + "/" + "0" + slick.slideCount);
// 		}
// 	);

// 	$(".o-single-product__images-container").slick({
// 		slidesToShow: 1,
// 		slidesToScroll: 1,
// 		arrows: false,
// 		dots: true,
// 		slide: ".o-slider__item",
// 		appendDots: ".o-single-product__vendor",
// 		infinite: true,
// 		mobileFirst: true,
// 		centerMode: true,
// 		centerPadding: "20px",
// 		responsive: [
// 			{
// 				breakpoint: 1024,
// 				settings: "unslick",
// 			},
// 		],
// 	});

// 	$(window).resize(function () {
// 		if ($(window).width() < 1024) {
// 			$(".o-single-product__images-container").slick("refresh");
// 		}
// 	});
// 	// }, 5000);
// });

/* ====== Product Detail Intersection Observer for current viewed Image thumbnail ====== */

var pdpObserverOptions = {
	rootMargin: "0px",
	threshold: 0.5,
};

var pdpObserver = new IntersectionObserver(
	pdpObserverCallback,
	pdpObserverOptions
);

function pdpObserverCallback(entries, observer) {
	entries.forEach((entry) => {
		var $currentTarget = $(entry.target);
		var $thumbnails = $(
			".o-single-product__slider--thumbnails .o-slider__item"
		);
		if (entry.isIntersecting) {
			var targetIndex = $currentTarget
				.closest(".o-slider__item")
				.data("nav");
			// console.log(targetIndex);
			var $targetThumbnail = $(
				".o-single-product__slider--thumbnails .o-slider__item" +
					'[data-nav="' +
					targetIndex +
					'"]'
			);
			$thumbnails.removeClass("active");
			$targetThumbnail.addClass("active");
		}
	});
}

document
	.querySelectorAll(
		".o-single-product__slider--main .o-single-product__slider-image"
	)
	.forEach((i) => {
		if (i) {
			pdpObserver.observe(i);
		}
	});

/* ====== Fancybox Gallery ====== */

$(document).ready(function () {
	$('[data-fancybox="gallery"]').fancybox({
		padding: [0, 94, 0, 94],
		buttons: ["close"],
		loop: true,
		infobar: false,
		btnTpl: {
			arrowRight:
				'<button data-fancybox-next="" class="fancybox-button fancybox-button--arrow_right" title="Next" style="background: url(https://cdn.shopify.com/s/files/1/0012/2290/1823/t/266/assets/icon_arrow.svg?v=3619327384766726052) no-repeat center center !important;"></button>',
			arrowLeft:
				'<button data-fancybox-prev="" class="fancybox-button fancybox-button--arrow_left" title="Previous" style="background: url(https://cdn.shopify.com/s/files/1/0012/2290/1823/t/266/assets/icon_arrow.svg?v=3619327384766726052) no-repeat center center !important; transform:scaleX(-1);"></button>',
		},
	});

	$(".o-slider__zoom-link").on("click", function (e) {
		e.preventDefault();
		$(".slider--simple .slick-current .o-slider__zoom-toogle").trigger(
			"click"
		);
	});

	$(".o-accordion__link--toggle-modal").fancybox({
		padding: [0, 0, 0, 0],
		buttons: ["close"],
		loop: true,
		infobar: false,
	});

	$(".c-menu__link--modal").fancybox({
		padding: [0, 0, 0, 0],
		buttons: ["close"],
		loop: true,
		infobar: false,
	});

	$(".o-block__play-button").on("click", function () {
		let blockVideoContainer = $(this).parents().find(".o-block__video");
		let blockVideoDataSrc = blockVideoContainer.data("src");
		blockVideoContainer.attr("src", blockVideoDataSrc);
		$(this).parent().addClass("o-block__play");
	});

	$('[data-fancybox="section--gallery"]').fancybox({
		padding: [0, 0, 0, 0],
		buttons: ["close"],
		loop: true,
		infobar: false,
	});
});

$(window).on("load", function () {
	$(".o-block__play-auto").each(function () {
		$(this).trigger("click");
	});
});

/* ====== Load More functionality and Scroll Restoration for Paginated Products on PLP  ====== */


function apiCallForPaginatedProducts() {

	let newPaginationUrl = $("#AjaxinatePagination .button--medium").attr(
		"data-href"
	);
	// console.log("request has been made for paginated products the server");
	$.ajax({
		type: "GET",
		dataType: "html",
		url: newPaginationUrl,
		success: function (responce) {

			const data = $.parseHTML(responce);
			let newContainer = $(data).find("#AjaxinateLoop").html();
			let loadMoreCtaHtml = $("#AjaxinatePagination");
			$(".background-loaded-tiles").html(newContainer);
			let newLoadMoreCtaHtml = $.parseHTML(
				$(data).find("#AjaxinatePagination").html()
			);
			loadMoreCtaHtml.html(newLoadMoreCtaHtml);
			$("#AjaxinatePagination").removeClass("c-button--loading");
			// console.log("paginated products data has been received");

			let page = $(data).find("#AjaxinatePagination").data('page')

			$(data).find("#AjaxinatePagination").data('page', page + 1)

			$(document).find("#AjaxinatePagination a").show();



			$('.swiper-card-vars').each(function(){

				var thisSwiper = $(this);

				var swiper = new Swiper(this, {
					// init: false,
					width: 280,
					autoplay: false,
					loop: false,
					slidesPerView: 'auto',
					// slidesPerView: 2,
					spaceBetween: 8,
					slidesPerGroup: 1,
					// centeredSlides: true,
					centeredSlidesBounds: true,
					navigation: {
						nextEl: $(this).find('.swiper-button-next')[0],
						prevEl: $(this).find('.swiper-button-prev')[0]
					}
				});

				var slides = thisSwiper.find('.swiper-wrapper .swiper-slide');
				var arrowPrev = thisSwiper.find('.swiper-button-prev');
				var arrowNext = thisSwiper.find('.swiper-button-next');



				if (slides.length < 6) {
					arrowPrev.hide()
					arrowNext.hide()
				}

			})

			$('.swiper-card-vars-mob').each(function(){

				if ($(this).find('.swiper-wrapper').children().length > 3) {

					var thisSwiper = $(this);

					var swiper = new Swiper(this, {
						// init: false,
						// width: 150,
						autoplay: false,
						loop: false,
						slidesPerView: 3,
						// slidesPerView: 2,
						spaceBetween: 8,
						// slidesPerGroup: 1,
						centeredSlides: true,
						centeredSlidesBounds: true,
						navigation: {
							nextEl: $(this).find('.swiper-button-next')[0],
							prevEl: $(this).find('.swiper-button-prev')[0]
						}
					});

					var slides = thisSwiper.find('.swiper-wrapper .swiper-slide');
					var arrowPrev = thisSwiper.find('.swiper-button-prev');
					var arrowNext = thisSwiper.find('.swiper-button-next');

				} else {
					$(this).find('.swiper-wrapper').css('justify-content', 'center')
					$(this).find('.swiper-slide').css('width', 'max-content').css('margin', '0 3px')
				}

			})






		},
		error: function () {
			console.log("request failed");
			$(document).find("#AjaxinatePagination a").hide();
		},
	});
}

window.onload = function () {
	// calling the scroll restoration function only on collection pages
	if (window.location.href.includes("/collections/") || window.location.href.includes("/search")) {

		setTimeout(function () {
			apiCallForPaginatedProducts();
		}, 500);
	}
};

// // Set a Cookie
// function setCookie(cname, cvalue, exdays) {
// 	var d = new Date();
// 	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
// 	var expires = "expires=" + d.toUTCString();
// 	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
// }

// // Get a query string parameter value
// function getParameterByName(name, url = window.location.href) {
// 	name = name.replace(/[\[\]]/g, "\\$&");
// 	var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
// 		results = regex.exec(url);
// 	if (!results) return null;
// 	if (!results[2]) return "";
// 	return decodeURIComponent(results[2].replace(/\+/g, " "));
// }

// if (window.location.href.includes("/collections/")) {
// 	let totalPaginatedPages = Number(
// 		$("#AjaxinatePagination").attr("data-paginated-pages")
// 	);
// 	let loadMoreCtaUrl = $("#AjaxinatePagination .button--medium").attr(
// 		"data-href"
// 	);
// 	if (loadMoreCtaUrl == "&view=endless-click" && totalPaginatedPages == 1) {
// 		$("#AjaxinatePagination").remove();
// 	}
// }

// // Get the Cookied URL(AjaxinatePaginationURL)
// var lastPaginatedUrl = getCookie("AjaxinatePaginationURL").split("; ")[0];

// var currentCollectionPage = lastPaginatedUrl.split("?")[0];

// // Extract the the page parameter value from the cookied URL
// var lastPaginatedPageNumber = Number(
// 	getParameterByName("page", `${window.location.hostname}${lastPaginatedUrl}`)
// );

// // function to restore scroll position of paginated products
// function scrollRestorationForPaginatedProducts() {
// 	// for checking whether URL string value isn't empty
// 	if (lastPaginatedUrl !== "") {
// 		if (!(window.location.pathname == currentCollectionPage)) {
// 			// clearing the AjaxinatePaginationURL cookie
// 			setCookie("AjaxinatePaginationURL", "", 1);
// 		} else {
// 			for (
// 				let paginationIndex = 2;
// 				paginationIndex <= lastPaginatedPageNumber;
// 				paginationIndex++
// 			) {
// 				// paginationUrl will be change and it'll have the updated URL string based on paginationIndex value
// 				let paginationUrl = `${window.location.pathname}?page=${paginationIndex}&view=endless-click`;
// 				// console.log(paginationUrl);
// 				// making a synchronous call using pagination URL's
// 				$.ajax({
// 					type: "GET",
// 					dataType: "html",
// 					async: false,
// 					url: paginationUrl,
// 					success: function (data) {
// 						var containerElement =
// 							document.querySelector("#AjaxinateLoop");
// 						var newContainer = $(data)
// 							.find("#AjaxinateLoop")
// 							.html();
// 						containerElement.insertAdjacentHTML(
// 							"beforeend",
// 							newContainer
// 						);
// 						$("#AjaxinatePagination").addClass("c-button--loading");

// 						/* ====== to remove the lazy Loading ====== */
// 						const images = document.querySelectorAll("[data-src]");
// 						images.forEach((img) => {
// 							const src = img.getAttribute("data-src");
// 							img.src = src;
// 						});
// 					},
// 				});
// 			}

// 			// setting href attribute to load more button
// 			$("#AjaxinatePagination .button--medium").attr(
// 				"data-href",
// 				`${window.location.pathname}?page=${
// 					lastPaginatedPageNumber + 1
// 				}&view=endless-click`
// 			);
// 		}
// 	}
// }

// // calling the scroll restoration function only on collection pages
// if (
// 	window.location.href.includes("/collections/") &&
// 	!window.location.href.includes("/products/")
// ) {
// 	scrollRestorationForPaginatedProducts();
// }

/* ====== Updated Navbar ====== */

window.addEventListener("scroll", function (e) {
	e.preventDefault();
	let pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
	let headerContainer = document.getElementsByClassName("l-page__header")[0];
	if( headerContainer ) {
		pageYOffset > 0 && pageYOffset > 10
			? headerContainer.classList.add("has-scrolled")
			: headerContainer.classList.remove("has-scrolled");
	}
});

/* ====== Updated Navbar ====== */

function mobileNavPosition() {
	// let navHeight = $("header").height();
	// $(".k-menu--main-mobile--level-one").css("padding-top", navHeight);
	// $(".currency-selector-view").css("top", navHeight);
	// $(".mobile-search").css("top", navHeight);
	// if (
	// 	$(".k-navbar").hasClass("k-navbar--bg-overlay") ||
	// 	$(".k-navbar").hasClass(".k-navbar--nav-bg-image") ||
	// 	$(".k-navbar").hasClass("k-navbar--nav-bg-solid")
	// ) {
	// 	$("#main").css("padding-top", navHeight);

	// 	if ($(document).width() > 768) {
	// 		$(".c-product-filter-facets__container").css(
	// 			"padding-top",
	// 			navHeight + 30
	// 		);
	// 	} else {
	// 		$(".c-product-filter-facets__container").css(
	// 			"padding-top",
	// 			navHeight + 15
	// 		);
	// 	}
	// }
	// if ($(document).width() < 1024) {
	// 	$(".k-menu--main-mobile--level-one").css("padding-top", navHeight);
	// 	$(".k-navbar-level--two").css("top", navHeight);
	// 	$(".k-navbar-level--three").css("top", 0);
	// }
}

mobileNavPosition();

function toggleMobileSubNav() {
	$("body").toggleClass("a-overflow");
	$(".k-navbar").toggleClass("k-mobile-nav--active");
	$(".k-navbar").removeClass("k-navbar--bg-overlay");
	$(".k-mobile-navbar").toggleClass("active");
	setTimeout(function () {
		$(".k-navbar-level--two").removeClass("active");
		$(".k-navbar-level--three").removeClass("active");
		$(".currency-selector-view").removeClass("active");
	}, 350);
}

// $(".k-menu__link--hamburger-menu").on("click", function () {
// 	$(this).toggleClass("is-active");
// 	mobileNavPosition();
// 	toggleMobileSubNav();
// });

$(
	".k-mobile-navbar .k-menu--main__item:not(.k-menu--main__item__birdword-container) .k-menu__link"
).on("click", function (e) {
	e.preventDefault();
	$(this)
		.closest(".k-menu--main__item")
		.find(".k-navbar-level--two")
		.toggleClass("active");
});

$(".k-mobile-navbar .k-submenu__item .k-submenu__link--level-two").on(
	"click",
	function (e) {
		e.preventDefault();
		$(this)
			.closest(".k-submenu--main__item")
			.find(".k-navbar-level--three")
			.addClass("active");

			$('.k-menu--main-mobile--level-one').addClass("active");
	}
);

$(".k-menu__link__level-three--back-cta").on("click", function () {
	$(this).closest(".k-navbar-level--three").removeClass("active");
	$('.k-menu--main-mobile--level-one').removeClass("active");
});

/* ====== Nav Elements Hover states ====== */

if ($(document).width() > 1024) {
	$(".k-menu--main__item--search").hover(
		function () {
			$(".cart-drawer-overlay").addClass("navbar--open");
		},
		function () {
			$(".cart-drawer-overlay").removeClass("navbar--open");
		}
	);

	$(".k-menu--main__item--first").hover(
		function () {
			$(this).find(".k-submenu__items li:first").addClass("active");
			$(".cart-drawer-overlay").addClass("navbar--open");
		},
		function () {
			$(this).find(".k-submenu__items li:first").removeClass("active");
			$(".cart-drawer-overlay").removeClass("navbar--open");
		}
	);

	$(".k-menu--main__item--first .k-submenu--main__item").hover(
		function () {
			$(this).siblings(".k-submenu--main__item").removeClass("active");
		},
		function () {
			$(this).siblings(".k-submenu--main__item").removeClass("active");
			$(this)
				.siblings(".k-submenu--main__item:first-child")
				.addClass("active");
		}
	);
}

$(".currency-selector-view-toggler").click(function () {
	$(".currency-selector-view").addClass("active");
});
$(".currency-selector-back-cta").click(function () {
	$(".currency-selector-view").removeClass("active");
});

$(".k-submenu__link--currency").click(function () {
	$(this).addClass("k-submenu__link--currency--active");
	$(this)
		.closest("k-submenu--main__item")
		.siblings("li")
		.find("a")
		.removeClass("k-submenu__link--currency--active");
	$(this)
		.closest("li")
		.siblings()
		.find("a")
		.addClass("k-submenu__link--currency--inactive");
});

// $(".o-cart-counter__item").on("click", function (e) {
// 	e.preventDefault();
// 	$("body").addClass("noscroll");
// 	$(this).addClass("active");
// 	$(".cart-drawer").addClass("cart-drawer--open");
// 	$(".cart-drawer-overlay").addClass("open");
// });

$(".cart-drawer__close").on("click", function () {
	$(".o-cart-counter__item").removeClass("active");
	$("body").removeClass("noscroll");
	$(".cart-drawer").removeClass("cart-drawer--open");
	$(".cart-drawer-overlay").removeClass("open");
	$(document).find('.product-card-plus.active').trigger('click');
});

$(".cart-drawer-overlay").on("click", function () {
	console.log('tetsesr')
	$(document).find('.product-card-plus.active').trigger('click');
});

/* ====== Desktop search result view fix for algolia container ====== */

$(".k-menu__toggle-mobile-search").on("click", function () {
	setTimeout(() => {
		$("#search-navbar-mobile").focus();
	}, 350);
});

$(".k-menu__toggle-search").on("click", function () {
	$(document).find(".aa-Autocomplete .aa-Input").focus();
	$("header").addClass("search-form--visible");
	if (!$('.search-opacity').length) {
		$('header').after('<div class="search-opacity"></div>');
	}
});

$(document).on("click", ".search-opacity", function () {
	$('.search-opacity').remove();
	$('.aa-ClearButton').trigger('click');
	$(document).find(".aa-Autocomplete .aa-Input").blur();
	$("header").removeClass("search-form--visible");
});

// $(".k-menu--main__item--search")
// 	.siblings()
// 	.hover(function () {
// 		$("header").removeClass("search-form--visible");
// 		$(document).find(".aa-Autocomplete .aa-Input").val("");
// 	});

// $(".k-navbar-user-links").hover(function () {
// 	$("header").removeClass("search-form--visible");
// 	$(document).find(".aa-Autocomplete .aa-Input").val("");
// });

// $(document).find(".aa-Panel").hover(
// 	function () {
// 		$(document).find(".cart-drawer-overlay").addClass("navbar--open");
// 	},
// 	function () {
// 		$(document).find(".cart-drawer-overlay").removeClass("navbar--open");
// 	}
// );

// $('.k-menu--main__item--search').hover(function () {
//     $(this).find('#search-navbar').focus();
//     $('header').addClass('search-form--visible');
// }, function() {
//     $('header').removeClass('search-form--visible');
// });

// $(document).find(".aa-Autocomplete .aa-Input").on("focus", function () {
// 	$("header").addClass("search-form--visible");
// 	$(".cart-drawer-overlay").addClass("search--open");
// });

// $(document).find(".aa-Autocomplete .aa-Input").on("focusout", function () {
// 	$(this).val("");
// 	$("header").removeClass("search-form--visible");
// 	$(".cart-drawer-overlay").removeClass("search--open");
// });

// $(document).find(".aa-Autocomplete .aa-Input").on("input", function () {
// 	let elmValLength = $(this).val().length;
// 	if (elmValLength < 1) {
// 		$("header").removeClass("search-form--visible");
// 	}
// });

/* ====== Covet Instagram Carousel Initialisation  ====== */

let isCovetInitialised = false;
let instBlock = this.document.querySelector('.covet-instagram-feed');
if ( instBlock ) {
	window.addEventListener("scroll", function () {
		if (window.location.pathname == "/" && instBlock) {
			let covetCarouselOffset =
				instBlock.offset().top / 2 - 200;
			if (!isCovetInitialised && pageYOffset > covetCarouselOffset) {
				const covetGallary = document.createElement("covet-pics-widget");
				covetGallary.galleryEmbedId = 121051;
				const wrap = document.querySelector(".covet-pics-wrap");
				wrap.appendChild(covetGallary);
				isCovetInitialised = true;
			}
		}
	});
}
/* ====== Announcement Bar ====== */

$(document).ready(function () {
	var pause = false;
	var announcementBarSection = $(".announcement-bar-section--text");
	var counter = 0;

	function setContentTopOffset(elm) {
		let headerHeight = $("header").innerHeight();
		$(".l-collection-page__filter-facets--scrolled").css(
			"top",
			headerHeight
		);
		if ($(".k-navbar").hasClass("k-navbar--nav-bg-solid")) {
			$("#main").css("padding-top", headerHeight);
		} else {
			$("#main").css("padding-top", elm.height());
		}
		mobileNavPosition();
	}

	setInterval(function () {
		if (!pause) {
			var $this = announcementBarSection.eq(counter);

			if (announcementBarSection.hasClass("active")) {
				announcementBarSection.removeClass("active");
			}
			announcementBarSection
				.removeClass("active")
				.eq(counter)
				.addClass("active");
			$this.addClass("active");
			setContentTopOffset($this);
			counter++;
			if (counter >= announcementBarSection.length) {
				counter = 0;
			}
		}
	}, 4000);

	$(".announcement-bar-section--close").on("click", function () {
		$(".announcement-bar").hide();
		let headerHeight = $("header").height();
		if ($(".k-navbar").hasClass("k-navbar--nav-bg-solid")) {
			$("#main").css("padding-top", headerHeight);
		} else {
			$("#main").css("padding-top", 0);
		}
		mobileNavPosition();

		setCookie(
			"announcementBarCookie",
			"announcementBarDisabled",
			0.0006944
		);
	});
});

let getAbCookie = getCookie("announcementBarCookie");
if (getAbCookie == "announcementBarDisabled") {
	$(".announcement-bar").hide();
}

/* ====== New Product Carousel  ====== */
$(document).ready(function () {
	$(".c-product-carousel__tiles__container").on(
		"init",
		function (event, slick) {
			$(this)
				.find(".c-product-tile")
				.removeClass("c-product-tile--hidden");
		}
	);

	$(".c-product-carousel__tiles__container").each(function () {

		let perview = $(this).parents('.c-product-carousel-full').length ? 6 : 5;

		$(this).slick({
			infinite: true,
			speed: 300,
			slidesToShow: perview,
			slidesToScroll: perview,
			prevArrow: $(this)
				.prev(".c-product-carousel____arrows")
				.find(".c-product-carousel___arrows--left"),
			nextArrow: $(this)
				.prev(".c-product-carousel____arrows")
				.find(".c-product-carousel___arrows--right"),
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					},
				},
			],
		});
	});
});

/* ====== Full width, Two Up Hero Banner and three up module Video ====== */

videoLoader(".c-three-up__tile__video__elm");
videoLoader(".c-two-up-banner__tile__video__elm");
videoLoader(".full-width-hero-banner__tile__video__elm");

/* ====== Neswletter signup state auto scroll ====== */

$(window).on("load", function () {
	if (
		(window.location.href.includes("?customer_posted=true") ||
			window.location.href.includes("?form_type=customer") ||
			window.location.href.includes("#scroll-to-footer")) &&
		$(".sign-up-popup").css("visibility") != "visible"
	) {
		$("html, body").animate({ scrollTop: $(document).height() }, 2000);
	}
});

/* ====== Neswletter signup state auto scroll ====== */

$(window).on("load", function () {
	$(".c-product-carousel___arrows--left").height(
		$(".c-product-tile__image__container").height()
	);
	$(".c-product-carousel___arrows--right").height(
		$(".c-product-tile__image__container").height()
	);
});

function productListingPageFunc() {
	/* ====== Product Collection Pages ====== */

	/* ====== Quick Add Button ====== */

	$("body").on(
		"click",
		".c-product-tile__variant-size__container",
		function (e) {
			$(".c-product-tile__variant-size__container").removeClass(
				"show-button"
			);
			$(this).addClass("show-button");
		}
	);

	$("body").click(function (e) {
		if (
			!$(e.target).closest(".c-product-tile__variant-size__container")
				.length
		) {
			$(".show-button").removeClass("show-button");
		}
	});

	/* ====== for product Filter Drawer Toggle ====== */

	$("body").on("click", ".c-product-filter__toggle", function (e) {
		e.preventDefault();
		let menuItem = $(this).closest(".c-product-filter__menu-item");
		let menuItemNextElm = $(this).next();

		menuItem.hasClass("c-product-filter__menu-item--open")
			? (menuItemNextElm.slideToggle(500),
			  menuItem.removeClass("c-product-filter__menu-item--open"))
			: (menuItemNextElm.slideToggle(500),
			  menuItem.addClass("c-product-filter__menu-item--open"));
	});

	// if ($(".l-collection-page__filter-facets").hasClass("active")) {
	// 	// $("body").addClass("noscroll");
	// }

	/* ====== Collection Page Filter Accordions ====== */

	var windowHref = window.location.href.toString();
	var newWindowHref = "";
	$("body").on("click", ".c-product-filter__link--toggle", function (e) {
		e.preventDefault();
		let elmClass = e.target.classList.value;
		if (elmClass.includes("c-product-filter__text--clear-all")) {
			var selectedFilters = $(this)
				.closest(".c-product-filter__menu-item")
				.find(
					".c-product-filter__submenu .c-product-filter__item--active"
				);

			const url = new URL(window.location.href);
			const params = new URLSearchParams(url.search);
			params.delete('sort_by');
			window.history.replaceState({}, document.title, `${url.pathname}?${params.toString()}`);
			window.location.reload();

		} else {
			var parentElm = $(this).parent();
			var cMenuSubmenuElm = parentElm.find(".c-product-filter__submenu");
			if (parentElm.hasClass("c-product-filter__menu-item--open")) {
				cMenuSubmenuElm.slideUp(500);
				parentElm.removeClass("c-product-filter__menu-item--open");
			} else {
				parentElm
					.siblings()
					.find(".c-product-filter__submenu")
					.slideUp(500);
				parentElm
					.siblings()
					.removeClass("c-product-filter__menu-item--open");
				cMenuSubmenuElm.slideDown(500);
				cMenuSubmenuElm.scrollTop(0);
				parentElm.addClass("c-product-filter__menu-item--open");
			}
			// if($(window).width() > 768) {
			//     if (parentElm.hasClass('c-product-filter__menu-item--open')) {
			//         cMenuSubmenuElm.slideToggle(500);
			//         parentElm.removeClass('c-product-filter__menu-item--open');
			//     } else {
			//         cMenuSubmenuElm.slideToggle(500);
			//         parentElm.addClass('c-product-filter__menu-item--open');
			//     }
			// } else {
			//     if (parentElm.hasClass('c-product-filter__menu-item--open')) {
			//         cMenuSubmenuElm.slideUp(500);
			//         parentElm.removeClass('c-product-filter__menu-item--open');
			//     } else {
			//         parentElm.siblings().find('.c-product-filter__submenu').slideUp(500);
			//         parentElm.siblings().removeClass('c-product-filter__menu-item--open');
			//         cMenuSubmenuElm.slideDown(500);
			//         parentElm.addClass('c-product-filter__menu-item--open');
			//     }
			// }
		}
	});

	/* ====== Filter container for Desktop and mobile ====== */

	var filterFacetsElm = $(".l-collection-page__filter-facets--md");
	$(".l-collection-page__filter-facets--sm").remove();

	/* ====== For making the product view filter and the filter toggle container sticky  ====== */

	if (filterFacetsElm.length > 0) {
		let footerOffset = $('.footer-new').offset().top;
		let filterFacetsElmOffset = $(filterFacetsElm).offset().top;
		let headerInnerHeight = $("header").height();
		let facets = $('.l-collection-page__filter-facets').height()

		$( window ).on( "load scroll", function() {
			footerOffset = $('.footer-new').offset().top;
			let windowScrollValue =
				window.pageYOffset || document.documentElement.scrollTop;
			let totalOffset = filterFacetsElmOffset - headerInnerHeight;

			filterFacetsElm.addClass('show')

			if ( windowScrollValue > footerOffset - (headerInnerHeight + facets) ) {
			// 	filterFacetsElm.addClass('show')
			// }else {
				filterFacetsElm.removeClass('show')
			}
			windowScrollValue > 0 && windowScrollValue > totalOffset
				? (filterFacetsElm.addClass(
						"l-collection-page__filter-facets--scrolled"
				  ),
				  $(".l-collection-page__filter-facets--scrolled").css(
						"top",
						headerInnerHeight
				  ),

				  $('.collection-page-content,.search-page-contentxxx ').css('padding-top', facets)
				  )
				: (filterFacetsElm.removeClass(
						"l-collection-page__filter-facets--scrolled"
				  ),
				  $('.collection-page-content,.search-page-contentxxx ').css('padding-top', 0),
				  $('main').css('padding-top', headerInnerHeight));
		});
	}

	/* ====== For product view filter  ====== */

	$(".l-collection-page__product-view-filters span").on("click", function () {
		let filterElm = $(this);
		filterElm.addClass("active");
		filterElm.siblings().removeClass("active");
		if (filterElm.hasClass("view-on-product-shot")) {
			$(".l-collection-page .c-product-tile").each(function () {
				$(this).addClass("c-product-tile--product-shot--active");
			});
		} else if (filterElm.hasClass("view-on-model")) {
			$(".l-collection-page .c-product-tile").each(function () {
				$(this).removeClass("c-product-tile--product-shot--active");
			});
		}
	});

	$(document).on(
		"click",
		".filters .l-collection-page__product-filters-toggler",
		function () {
			$("body").addClass("noscroll");
			$(".l-collection-page__filter-facets").addClass("filteractive");
		}
	);

	$(document).on(
		"click",
		".sorty .l-collection-page__product-filters-toggler",
		function () {
			$("body").addClass("noscroll");
			$(".l-collection-page__filter-facets").addClass("sortactive");
		}
	);

	$(".c-product-filter-facets__close-icon").on("click", function () {
		$("body").removeClass("noscroll");
		$(".l-collection-page__filter-facets").removeClass("filteractive sortactive");
	});

	$(document).on("click", ".c-product-filter-facets", function (e) {
		let elmClass = e.target.classList.value;
		if (elmClass == "c-product-filter-facets") {
			$(".l-collection-page__filter-facets").removeClass("filteractive sortactive");
			$("body").removeClass("noscroll");
		}
	});

	$(document).on("click", ".active-facets__header .close", function (e) {
		$(".l-collection-page__filter-facets").removeClass("filteractive sortactive");
		$("body").removeClass("noscroll");
	});

	/* ====== for Product Filter action ====== */

	$(".c-product-filter__link").on("click", function (e) {
		setTimeout(()=>{
			activeSort();

			let selectedFitersLength = $(".c-product-filter__submenu .c-product-filter__link--active").length;
			$(".selected-filters-length").text(selectedFitersLength);
			$(".c-product-filter__tag-removal-cta--all").show();
			$(".c-product-filter__text--clear-all").addClass("has-selected-filters");

		},200)
	});

	/* ====== For adding clear all cta in sort by filter ====== */

	function activeSort() {
		$(".l-collection-page__filter-facets").addClass("active");
		const urlParams = new URLSearchParams(window.location.search);
		const sort = urlParams.get('sort_by')

		$('[data-name="sort_by"]').each(function (index, item) {
			$(this)
				.closest(".c-product-filter__submenu")
				.closest(".c-product-filter__menu-item")
				.addClass("c-product-filter__menu-item--open");

			if($(this).parent().data('tag') == sort) $(this).addClass("c-product-filter__link--active").parent().siblings().children().removeClass("c-product-filter__link--active");
		});
	}

	let windowUrl = window.location.href;

	if (windowUrl.includes("sort_by")) {
		activeSort()
	}


	/* ====== For counting the number of applied filters ====== */

	$(document).ready(function () {

		let selectedFitersLength = $(
			".c-product-filter__submenu .c-product-filter__link--active"
		).length;

		var isSearchResultsPage = $(".ais-page").length > 0;

		if (isSearchResultsPage) {
			selectedFitersLength = $(".ais-facet--active").length;
		}

		$(".selected-filters-length").text(selectedFitersLength);

		if (selectedFitersLength < 1) {

			$(".c-product-filter__tag-removal-cta").hide();

			$(
				".l-collection-page__product-filters-toggler .selected-filters-length"
			).hide();

			let word = $(window).width() < 992 ? "Filter & Sort" : 'Filter'

			$(
				".l-collection-page__product-filters-toggler .selected-filters-text"
			).text(word);

		} else {

			$(
				".l-collection-page__product-filters-toggler .selected-filters-length"
			).show();

			if (selectedFitersLength === 1) {
				$(".selected-filters-text").text("FILTER APPLIED");
			} else {
				$(".selected-filters-text").text("FILTERS APPLIED");
			}

			// $(document).find('#AjaxinatePagination').addClass('hard-hide');

		}

		// $('.ais-facet--option').click(function() {
		//     var filterCount = $('.ais-facet--active').length;
		//     $('.ais-facets .selected-filters-length').text(filterCount);
		// })
	});

	/* ====== For adding the clear all cta in filter item ====== */

	$(".c-product-filter__menu-item").each(function () {
		let activeFiltersLength = $(this).find(
			".c-product-filter__submenu .c-product-filter__link--active"
		).length;
		let filterItemsLength = $(this).find(
			".c-product-filter__submenu .c-product-filter__item"
		).length;
		if (activeFiltersLength > 0) {
			$(this)
				.find(".c-product-filter__text--clear-all")
				.addClass("has-selected-filters");
		}
		if (filterItemsLength == 0) {
			$(this).remove();
		}
	});

	/* ====== For keeping the filter drawer open on page load if the user has selected the filter item ====== */

	$(".c-product-filter__item").each(function () {
		let windowHref = window.location.href;
		let tagName = $(this).attr("data-tag");
		if (windowHref.includes(tagName)) {
			$(this).addClass("c-product-filter__item--active");
		}
	});

	if (
		$(".c-menu-item-clothing").is(":visible") ||
		$(".c-menu-item-accessories").is(":visible") ||
		$(".c-menu-item-shoes").is(":visible")
	) {
		$(".c-menu-item-other-product-sizes").remove();
	} else {
		$(".c-menu-item-other-product-sizes").show();
	}

	/* ====== For Other Size filter ====== */

	if (
		$(".c-menu-item-clothing").is(":visible") ||
		$(".c-menu-item-accessories").is(":visible") ||
		$(".c-menu-item-shoes").is(":visible")
	) {
		$(".c-menu-item-other-product-sizes").remove();
	} else {
		$(".c-menu-item-other-product-sizes").show();
	}

	let numberOfSearchResult = $(".ais-stats-container").html();
	$(".ais-stats-container--sm").html(numberOfSearchResult);
}
productListingPageFunc();

/* ====== To trigger signup popup on pdp ====== */

$('a[href="#js-sign-up-popup"]').on("click", function (e) {
	e.preventDefault();
	$(".sign-up-popup").removeClass("sign-up-popup--remove");
});

/* ====== Birdword Blog ====== */

$(document).ready(function () {
	initBirdwordModules();

	var handles = $("#latest-article-handles").text().split("__");
	$(handles).each(function (_index, handle) {
		$('[data-handle="' + handle + '"]').hide();
	});
});

function initBirdwordModules() {
	$(".birdword-nav--mobile-trigger").click(function () {
		$(".birdword-nav--mobile-container").addClass("open");
	});

	$(".birdword-nav--mobile--close").click(function () {
		$(".birdword-nav--mobile-container").removeClass("open");
	});

	$(".shopping-module__button").click(function (e) {
		$(this).closest(".shopping-module__button").fadeOut();
		$(this)
			.closest(".shopping-module__button")
			.siblings(".shopping-module__actions--reveal")
			.addClass("visible");
		if ($(this).closest(".__pf").length > 0) {
			e.preventDefault();
			$(this)
				.closest(".shopping-module__product-tile-container")
				.find(".shopping-module__actions--reveal")
				.addClass("visible");
		}
	});

	$(document).on("click", "[data-quantity-modifier]", function (e) {
		var quantity = parseInt($(this).siblings(".item-quantity").text());
		var action = $(e.target)
			.closest("[data-quantity-modifier]")
			.data().quantityModifier;
		if (action === "add") {
			if (quantity < 5) {
				quantity += 1;
			}
		} else if (action === "subtract") {
			if (quantity > 1) {
				quantity -= 1;
			}
		}
		$(this).siblings(".item-quantity").text(quantity);
	});

	$(".shopping-module__actions .custom-option").on("click", function () {
		var variantIdFormField = $(this)
			.closest(".shopping-module__actions--reveal")
			.find("[data-form-add-to-cart]")
			.find("[data-product-select]");
		// console.log("Variant field", variantIdFormField);
		variantIdFormField.prop("value", $(this).data().variant);
	});

	$(".shopping-module__products").each(function () {
		$(this).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			prevArrow: $(this).find(".shopping-module__arrows--left"),
			nextArrow: $(this).find(".shopping-module__arrows--right"),
			dots: false,
			slide: ".shopping-module__product-tile-container",
			// appendDots: ".o-single-product__vendor",
			infinite: true,
			mobileFirst: true,
			centerMode: true,
			centerPadding: "0px",
			responsive: [
				{
					breakpoint: 1024,
					settings: "unslick",
				},
			],
		});
	});

	$(".pf-shopping-module--mobile").each(function () {
		$(this).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			prevArrow: $(this)
				.closest(".pf-shopping-module-container")
				.find(".shopping-module__arrows--left"),
			nextArrow: $(this)
				.closest(".pf-shopping-module-container")
				.find(".shopping-module__arrows--right"),
			dots: false,
			// slide: ".shopping-module__product-tile-container",
			// appendDots: ".o-single-product__vendor",
			infinite: true,
			mobileFirst: true,
			centerMode: true,
			centerPadding: "0px",
			responsive: [
				{
					breakpoint: 1024,
					settings: "unslick",
				},
			],
		});
	});

	$(".sticky-shopping-module__products").each(function () {
		$(this).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			prevArrow: $(this)
				.closest(".sticky-shopping-module--pf")
				.find(".shopping-module__arrows--left"),
			nextArrow: $(this)
				.closest(".sticky-shopping-module--pf")
				.find(".shopping-module__arrows--right"),
			dots: false,
			infinite: true,
			mobileFirst: true,
			centerMode: true,
			centerPadding: "0px",
			responsive: [
				{
					breakpoint: 1024,
					settings: "unslick",
				},
			],
		});
	});

	$(window).resize(function () {
		if ($(window).width() < 1024) {
			$(".shopping-module__products").slick("refresh");
			$(".sticky-shopping-module__products").slick("refresh");
		}
	});

	$(".shoppable-carousel").each(function () {
		$(this).slick({
			slidesToShow: 4,
			slidesToScroll: 4,
			arrows: true,
			prevArrow: $(this)
				.closest(".shoppable-carousel-container")
				.find(".shopping-module__arrows--left"),
			nextArrow: $(this)
				.closest(".shoppable-carousel-container")
				.find(".shopping-module__arrows--right"),
			dots: false,
			infinite: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		});
	});
}

$(document).on('click', '#mobileMenuToggle', function(){
	$(document).find('.aa-DetachedSearchButton').trigger('click');
})


$(document).on('click', '.bcpo-image-parent', function(){
	let variant = $(this).find('input[type="radio"]').attr('value')
	$(document).find('.slider--thumbnails').find('img[data-variant="'+variant+'"]').trigger('click');
})

// $(window).on("load", function () {
// 	// $('.shoppable-carousel').slick('refresh');

// 	var pdpSupportingTextOther = $(".pdp-supporting-text").attr(
// 		"data-alt-text"
// 	);
// 	// console.log("Other: ", pdpSupportingTextOther);
// 	var country = GlobalE.Country;
// 	// console.log("COUNTRY: ", GlobalE.Country);
// 	if (country !== "GB") {
// 		$(".pdp-supporting-text").text(pdpSupportingTextOther);
// 	}
// });

/* ====== Search Query Parameter (Keep this snippet at the bottom of file) ====== */
// function searchQueryParams(event) {
// 	var eventCode = event.keyCode || event.which;
// 	if (eventCode === 13) {
// 		var query = `/search?q=${$(this).val()}`;
// 		event.preventDefault();
// 		window.location.href = query;
// 	}
// }

// $(document).on(
// 	"keypress",
// 	".o-search-from__field--desktop",
// 	searchQueryParams()
// );

// $(document).on(
// 	"keypress",
// 	".o-search-from__field--mobile",
// 	searchQueryParams()
// );

// ajaxCartSwitch()
// $(window).on('resize', ajaxCartSwitch)
// function ajaxCartSwitch(){
// 	if ($(window).width() > 768) {
// 		console.log('desktop');
// 		$("body").find('#add-to-cart').removeAttr('data-add-to-cart-ajax')
// 	} else {
// 		console.log('mobile');
// 		$("body").find('#add-to-cart').attr('data-add-to-cart-ajax', '')
// 	}
// }


// Shopify.onCartUpdate = function(cart) {
// 	alert('There are now ' + cart.item_count + ' items in the cart.');
//   };
